<div class="containerBanner-dashboard">
  <div class="scan-cls d-flex justify-content-between">
    <div>
      <h1>Overview</h1>
      <p style="font-size: 16px">
        See Your Latest Overview of your
        <span style="opacity: 35%; font-weight: 600 !important; color: #030303"
          >Dashboard!</span
        >
      </p>
    </div>
    <button
      class="scan-btn"
      data-target="#scanQRoptionModal"
      data-toggle="modal"
    >
      Scan QR
    </button>
  </div>

  <!-- Scan QR Code option Modal -->
  <div
    class="modal fade"
    id="scanQRoptionModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="scanQRoptionModalTitle"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered charging-reminder-width"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header charging-head">
          <h5 class="modal-title">Add Inventory Item</h5>
          <button
            type="button"
            class="close inven-cls"
            data-dismiss="modal"
            aria-label="Close"
          >
            <svg
              class="cross-svg"
              width="14"
              height="12"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5518 1.64453L1.85612 12.3402"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
              <path
                d="M12.5518 12.3401L1.85612 1.64445"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
        <div
          class="modal-body d-flex justify-content-center"
          style="padding: 8rem 2rem"
        >
          <button
            type="button"
            class="close scan-btn"
            style="margin-right: 30px; opacity: 1"
            (click)="openScannerModal()"
            data-dismiss="modal"
            aria-label="Close"
          >
            Scan QR Code
          </button>
          <button
            type="button"
            class="close manual-btn"
            data-target="#manualModal"
            data-toggle="modal"
            data-dismiss="modal"
            aria-label="Close"
            style="opacity: 1"
          >
            Create Manually
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Only Scan QR Code Modal -->
  <div
    class="modal fade"
    id="qrScannerModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="qrScannerModalTitle"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      role="document"
      style="max-width: 700px"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Scan Product QR Code</h5>
          <button type="button" class="close" (click)="closeScannerModal()">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <!-- QR Scanner Component -->
          @if(scannerEnabled){
          <zxing-scanner (scanSuccess)="handleScanSuccess($event)">
          </zxing-scanner>
          }
        </div>
        <!-- <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeScannerModal()">Close</button>
      </div> -->
      </div>
    </div>
  </div>

  <!-- After Scanning select request Modal -->
  <div
    class="modal fade"
    id="selectReqModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="selectReqTitle"
    aria-hidden="true"
    style="backdrop-filter: brightness(0.5)"
  >
    <div
      class="modal-dialog modal-dialog-centered charging-reminder-width"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header charging-head">
          <button
            type="button"
            class="close inven-cls"
            data-dismiss="modal"
            aria-label="Close"
            (click)="closeSelectReqModal()"
          >
            <svg
              class="cross-svg"
              width="14"
              height="12"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5518 1.64453L1.85612 12.3402"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
              <path
                d="M12.5518 12.3401L1.85612 1.64445"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
        <div
          class="modal-body all-req-content d-flex justify-content-center"
          style="padding: 8rem 2rem; gap: 10px"
        >
          <button
            type="button"
            class="manual-btn"
            (click)="openServiceRequestModal()"
          >
            Service Request
          </button>
          <button
            type="button"
            class="manual-btn"
            (click)="openInventoryRequestModal()"
          >
            Inventory Request
          </button>
          <button type="button" class="manual-btn">Return Request</button>
        </div>
      </div>
    </div>
  </div>

  @for (overdue of overdueAssets; track $index) {
  <div
    class="modal fade"
    id="assetOverdueModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="forwardRequestTitle"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered forward-req-width"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close inven-cls"
            data-dismiss="modal"
            aria-label="Close"
          >
            <svg
              class="cross-svg"
              width="14"
              height="12"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5518 1.64453L1.85612 12.3402"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
              <path
                d="M12.5518 12.3401L1.85612 1.64445"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
        <div class="modal-body forward-req-container text-center">
          <div>
            <svg
              width="82"
              height="82"
              viewBox="0 0 82 82"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <rect
                x="0.0761719"
                y="0.44043"
                width="81.4707"
                height="81.4707"
                fill="url(#pattern0_2279_1138)"
              />
              <defs>
                <pattern
                  id="pattern0_2279_1138"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlink:href="#image0_2279_1138"
                    transform="scale(0.00390625)"
                  />
                </pattern>
                <image
                  id="image0_2279_1138"
                  width="256"
                  height="256"
                  xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAAAgAElEQVR4Ae29CXgc2XUeWthJYu1ubCTBbUZWHMlW7Mi7HVvOi99nK3bey8uTYzuf/PLsWE9+L1aiRJbi5LM/WEOgq7obvXHGlsaybEtW7Iw90hALV6AXgNtwuAENkBop9mixZ0iCAAESRHfXcs/TuVWnu7rRDTQaO3D5fZe3UF1169ap+//33HPPPVeSxD8hASEBIQEhASEBIQEhASGB3SuBildekaq6u6XKYq+Iv+E1kiRVFLtGnBcSEBLYQRJAUOeDHiSp4v4XpPrp062N06elxrcHpAP5oC903w56bVFVIYE9LwHe45MUZl493DUzeOLXZwaOf/7JmePXHp0+dH/6K+1zj/s75uYH2u8/O9d5LXm+7XPJcy0fXhiq76T7hEZAkhC5kMAOkYAFWl7bh6ePff90/4kvTPc/9+TR0Al4fPZdMHf2OSsdh4XzRyF54QikRw5DeuQgpCNtkIo0P16INH/+6fmG76FXztci6LzIhQSEBLaRBAj8bw8cOjB75mj40dARwDR95gg8HDys3x88pD0a7NLnzh01no4cY8noMabGjhhq9Iiuxg5r6Wibnoq2wWKsDRZirfpCvNX79TNSHb4ilb2NXldURUhASIAkEO2WqvH4nTPO98yePXjv8ZkumB06xB6dOaRNnz3EHp7pYA8HO2B6qI3NXehkTyNdsBg9DIvRToYpFe2AZMTFMC1GW7WFeBtgehZrG09Fm96FZdMz6JkiFxIQEtgGEqDe+f5Q1w8/GjoyP3v2KMwOHVEfnznCZocOw+zZg+zx2Q725FwbPL3QBs+G2wB7egR9NrVBOtLKUlEnS0VdsBhzsmTcpSbjraBGHdPqxZbvx1elZ22D1xZVEBIQEiBAvvPa0fdMDxx9Mj14FB4NHVMfDR0DkwAOsblzh+Hp+YOweKEdksMuSI04zcRJwCQDHP+noy4rtbBUrIWl405Ixx0q5mqseTo1Uvc8SlzYBES7ExLYHhLgc/b3v9BRP33m2FcR/NODRzn4Hw0dZUgAOBR4eqELFi50QvJiB6RGWi2QO2yAN4GvRVygRRygRxHwDpaOY3KCOupU1VEXaPGWWzc+K9VYry78BbZHGxC12KsSoN7/4dCRFx8OmeB/OHAEpgePsOnBw1z9f3z2ECeAZ8MHlyUAAj8RgJ0EEPxEAum4S0Z507P3quzFewsJbKkESA2fHjz4fgT/w8Fj7OFAl5UOsYcDh2Fm8BDMnzkECxe6IDlyCFIj7aCNtEEW7NjjZ5M+4gKeok5LCzA1AT3uZGZygR53qulh53vw5akOWyoI8XAhgb0oAQLf9EDXl5AA7g8c1bD3f9B/mIP/Uf9hmB04BE/OHuYEgHP92khHGQTgRNAzPW6CX405QY85X0aZUx32ovzFOwsJbKUE+Pj77VcPHns4eHghVwM4Atj7IwHMDR7mBJAc7gI1egj0SCfo0XbQo628h7f3/nhcWANAAuDgRy3AQAIwxlpnF6IZj0FhC9jKliCevfckQPPx0/2HPzI92AUPh45ofAjQf5SZNoAumBnogvmhLnh67jDkEoAJfhzjl0EALB1p0Y2xNlBjLR9GyQtbwN5rf+KNt1gCpHrPDhz9M+7pN3RCezj4HEwPHAckAAT/7NCRDAGkhg9xV197748EYGoCSAjLJ+z1ueofd7J0tEVFAtAjjs8KAtjihiAev3clgD3v9ODRm5wABo/rDwdPME4A/cdgdhB9ALoy439OAJGOHPW/XAJIjTRzDUCLtoztXemLNxcS2GIJTL3S1vDwTNejR2cOw/TgcWN66DlOAEgCRABPzx2BhQtm759ePwIw2KV2UCPN33jrT6R9WywG8Xghgb0pga/iev4zR+Y5AQwdZ9NDz2eGAKj+z509Yq32M1f64fQfGf/0WAs3Aq6k+tPv2SGAC5LDTZwAtGjz7MNXpIa9KX3x1kICWywBJAD0+ycCQBvAw/5j3AaABIBDAFzumxruAj1yiKv/LNIKLOoEFm3huQlwnBXIT/k2AdMvwIi7IH2xyYCxdhAEsMUNQDx+b0vg4SttDY8Gux4h2B8NHjfQBoAE8KDfnAFAD0B0AFpfAnAyIgB9RAwB9nYLFG+/pRJAI+DswLFbFgFwI2BhAjgEajR3/p8PAfgwIL+nL/Y3aQBOpg4361wDiDQJI+CWtgDx8D0rgew0YNcXOAFY04B2AsBlwOgDkIoc5gSgcjUfvfhaQI81mXnJU4E2AhhpVtloG6gRx2fwAwg/gD3bDMWLb5UEyBFoduDwR+cGMerP0RxHIPQENAngCKRGjkA6ilpAO5/LV+MtoMabeCo+FWgC3vydjh1MjzqYNtKioy1AHRGOQFv1/cVzhQS4++07X+k8PtN/8Bmu/c8uBjJdgU0SOAjPLh7mBJCOdYIaa4U1EUDEYZirBR2zC8P1HdZnEK7Aoj0KCWy2BGgYMDPY9hfoDMTdgQcQ/LgiEBcFHTJXA54/DMlYl0UC7cCDfIyiBtBiagRIClaiab/cnh81AOz9ea7yPOL8HL4v1WGz3108T0hgz0uAwPeo3/WDFgHYlgObJPBo4CDMDh2EheEjJgnEOiEdbzVJgEf5yYIfSaAwAZiqv50E0hHne/EDUB32/McQAhAS2AoJEAAfDB35QwoIwqMCDRxjGBTkUb+5LmDu/DFYjByDdLQLcCiQjqEmgLH+2nPSUgIg8Gd7f23EIQKCbMXHFs8UEiggAT7+Rp+Ah4NHvkYhwdAdeHrgGHt0+iibGTgKGCT0yfAJSEaP55DAUgKgpcKoDbiYmfixiuSgRVpvipBgBb6COCUksFUSoGm4+691fe+jgSMLCPjpgeMqbgQyY5EAEsPc+ROwGEESOArJ2CGuCaB/APcRwDgBmVgBSAJtzEz8WLU8BR+mRtpFUNCt+tDiuUICxSRAJDB7+uiPPzrdtYCq/+zgMRUJAH0DcDgwe/YIe3rhKB8KIAngcACDhOQSQBb4RqyDGaOdKmoJixcc02q07fvw+fSsYnUR54UEhAS2QAIZ34DXur53bujgm3NDB83goAPHNG4PGOpiuEBo/nwXe3axi3H/gBF0EjrI1GgHT7zXj7QZasylGqMdoF/qhMURx625M82854eoufnIFryeeKSQgJDAShKg3vn++ffV//3Qe196Z/AEWMZBmB44rM8OHsJkzJ07xJ6eO8QWLnSw5MV2pkY6DDXaoakc/OYsQXK0UVsYrVNozE9lr1QH8buQgJDA1kmg4sZn309x+6Vvj/zADz0Y6vrSg8HDT6eHDoGZOuHRmYMwe6YNHp9r5TsFJUfabTsEOWefjR34/Oyo9D58DdxOHG5k9gLYujcTTxYSEBLIkQDfAhy6pWoEac4veX+8PdRybOaC8z/MnGt+deZ889dmzzemZy/Us8fDB9j88P7k00jD1GKs6UsLoy3/9ul5qT3v9pw/oVuqxKGANQW57HNzbhR/CAkICaxNAgg6GuvnlwSflWoWzxzuSsaf/6dzo+/+jZl4V/f8WOOfPblUdfbp5arIsyvVbyxcqfrbhauVT55dqzQWX69mz65JLHVN0tQ3KmfVN6on9ZvVEe12xYV0Qno1NSm9lLwn/c7ClPQr2oT0o3BLakPwL3muJFVEs4SQ/7P4W0hASGAtEkDQFxp/w5mGNhg58HMQa/pdiLf9NYu1f82IdyTVMQckr9TBs2sVkHpDAvWWBNp4JU/6uAT2ZExIgAmmKgHuVgHcqwZ4swrgf1YC+3oFqF+TQH9TAjZVwSAhPYEJ6Q5MSF+EhPSf4Xb1B+C21JL/blhXclDK/038LSQgJFCaBLh6b78UjXGLw4d/NB3p/D0t3j6sjjrmUlcckLraCOxaPcC1BoCr9aBe38eejVfrTyckNXVH0tK3JV2fkHQ9IRl6QmLLJEO7I+npCUlXE5KmJiRVm5RUY1IyIFENkKgEmESyQEKoBDZVDcaU9FCfkgYhIf22Oi7943zgW8Qlhgn2DymOhQSKSQABZAcRHj8ebfip+UtNgaejzjcXR9shGW+H5KgTkpeb4dm1BrZ4fb+qXavS4I0qA27WMP1OFXt2t5I9uysxdZIAXwF6YmlSExWASZuq4sm4Ww3G3SrG7lUyE+QVDCarGCSqGExWMJiSdJiSNGOqQtPuVTBtSgJMhpmYek8aT09JvYtT0g/b3zH/vey/iWMhgT0vgXwVP3Wh7bu0WPvvpsacCQR68nI9LF46wFPy8gE1dWWfnrpex1LXa1j6RjUzblQC3JQY3KlkxngVB7U6KWVBP1EFeqFkIwVjsgowYc/Oe/fJKoBJ7PmrACaqABISEgBjdyUw7knMJIBKQ5us1IxEpWbej2RiEoo6WXnDSEifSE5JR20feIlmY/tNHAoJ7C0J5ANfi3b8Mz3W9ooab0/ijrypS82QunyAJa/Uqsmr1cbi67Uc9Knr1ZC+UcnUm9Vg3KoCdquCJxivAGMCe3oE/+oIoJCGwMGPBJCo4Oo/gt8iADDuogZQybTJGjAS1YyniWrdmKjWjMlKRoRgTEpP9Enpz7RJ6cftXzf/3e2/iWMhgV0tgfzGn445P6TGnZf5NtxjDlDHmiE11qClLh3Qk1dqWepaLUu/XsPSb9Qy9WYtaLfqQLtVA/qdatDvVAK7XQnsDhr07OBfOwEYkxWQSTj2twiA51OVXGPgQE8QCVg5EkCiUjcSksbvt4YJ+qQ0oiekn7d93Ar7kMd2XhwKCew+CeSPhfXRg/9KHW2/iUE6UrFmSMUPGOnR/Vrq8j6WuozAr4PUtWqmvlED2g0EPoK+FozxOjDGawDVfUwIfm7dz/T866MB2MGP4/wMAXAjYD4BIPhtBMCHFBIzJnnSjCmJWbYC0CelS3pC+uf0hS1CFMZCEojId58EcK6c3ioZ6fwpbaxrVL9yGLTLnZCKNunJ6H79WbyGJS9XMfVaJdOvVzLthqnimz19tQn6RJ0FtBre42OvbyYCvT23DH+Fxv/LnbNsAxkCsDQB0zCIMwBmMtV803aQ1QRqspqBCX4iAWYkJNQKdDQcqnclSN+Vzi/elX6E5JKvGdF5kQsJ7FgJ2J1nFs87j+jxjj9X452gjR0E7dJBXbvUoSdHm1l67ACkrlRz4OOYHm5LAOMVAFYvz3t77GEtYx3PbeDH+fzs2J+Ot5oAaAhBmgAaCCWcPdDVu5KRuicBpuRd6eWFhJSJMWiX2Y798KLiQgJ2rz0j0vExI9oxZ8Q6wYi1GWrUpaeiTqZeagPtioPp1xoYu1HHx/OAzjmYxs1xfaaX5+AnUGHPbzryUF6UAMjav1yvb/9t3TQAW10nM+Dn04fqPYmpdyVNxenKuxWgTlU+VCer/h21GqENkCREvhMlkDFupSKN/0AbbYnqcRdgYqOtqhFvYeloMySjjUy93MKM11sAbjYA3Kkze32LAIxELsDzVXICPuW5BGD1/gR+zO0gX+54wwiApgklpt3lydQIJiVVnaoBdaoO0lO1Z5K39x3Hj24ZCIVtYCciYK/W2d5zpaLNH02ONS7y6byxJk293GRoV5tAv9bEe3z1Sj2oV/cDu9UAMF4PMF6XmXLjXnfoeZfI7UWXkIDdUm8fHuAxN8qRca5Ann990b+pDrbxftFrC11D99tyy3mIGwdRO5isNtTJWg1JQEtUz6mTVb9KbcguUzonciGBbScBMvThrrn6sPMv0Lq/ONYCi6ONWvJyI6Reb4DU6/sZzuerN/aBcbMOjDdqgd2uNcE/UZNLADj/vlsJIENcaB8w/Qa0yWqmJao10zORT2l+/utnpDr80CTbbffRRYWEBFAC1EstDDvelxppfTMdaYN0tE1Lxl3G4hi67jaxZ1dr2cLVSli8LvH5e+5hh4Y+7mmHDjeW003JoC/U29rObVsNwFbHjCaBJFDJTPBXGupdbiiE9D3pzpN70rvtMhYtTkhgO0kAx6h8nJoeaftQOtKRTEc6IBVtV5PxDoa++4tjDpa83MCeXa2B1BuVfM6ee9clUMU31Xzz7zX2+BkwWQDbUQSAdc4hAYaLkUzXYmk+NSF9ED86j0ewQvyD7dQ4RF12twQyBipjxPUpZm22ieG1MP4+EsDiqIstjjVB6mo9pG+gI0+luQQXx/eULFXfTgJ21d8EARnQsnnOlGA++PHvdSOAQj32+p/Luh5XMkhgQu1I0kwNiR//f7bmlJG97Zw4FBLYHAnYXViNEVeYRVuARRuZHm3W1ZgT0nEXS446OPhxMY96fb/pxcfn7iVAC78ggFwSyRIALkBCApBMEhiv1DkJTEqgJaRe2xcWJGAThjjcJAnYwb8Ya/8iLs9Nxxt1NV5vqKMHID22n6XH6ljyUi0kUe2/Xgv67X3ck49PxS2ZZiMg2KzklpGsWO+P51fUAAppBTvinDkUMgkASQC1mWoDE9oI1CmJb02On9v+LTbp84vH7GUJ2Bvck9HOv8I1+oujDo178402AAI/PVYL6UuVkLpaAeobVXzRDvru58/DLwVwLgEsB/7dTgB8uhOnCrk7MS4uqgEtsY9piVoNXYnTd6U/s7VDoQnYhCEON04CmYb2ZLTtrxbjuM9eh4rqvrnrbiN36UUCUC9XgX69ii/XpUU7GY8+y4U3R+VdZgagGBEsJRDSJHZ6bhJh9r2r0E+AaZN1oE3WMoxBgN6DC28KEti4pi5KzpdABvyLo64vLoy1opFP5Ztq4Pba8WaW5hrAPlAv14B+Hd16cX7fXLGXD378WxBAMaIqRAA1FviRBKqZOiVpz96UIPnV7HCAZmPyP5z4W0hgPSTACcCIOk4lR1tgAdV+3vPjFtsOpsabgC/ouVxngv/WPoA72SW79rE/Bd/YeALIHVIs9SIsBsCtPp9fb6s+fFajmvsK4BqC5JuSlnqTT6Vyw6B9eLYeH1yUISTAJUBOPkbU8SkWbYLkaL2+ONbIkAjS8eYi4Mc1+2bvnxn72/3y+dQfOf9QXtgPIKsKZ6cAS7MB5AMp/++tBnqx5y9fT4xEhMuJU1+VmPpVycBApTAh/Xv8WPStRNMVElgXCZALajrW9iE91gJ6vJ6lx/YbybEDkByrt9T+A6Bd2c97frhVy3t+Uv2pty+UF9MAyB+Aeuy9RwDFiCF7npMAD2ZaaZi2kAogZyH6ZuvSAEQhe1cC1JssRFr+kRppT+H8vhpr1NXRfZAeq2EmCZjgZ9f2A9zcB3C7xhz38/BcBVbk2bQAQQBZQK/aoImzAtwgWAcGxiKcxMjG0nzqjnAb3ruIXd8352P+h1GpIR1zfk1FQ1+0TeMkMGpO9aUu7wdc0cfBf+MAwG1czlsFkAnOKQhg1cAuyU8BhwhIHqbrMD+m+IMJ6c7UK1Kt1RQyhtv1bRqitF0vAdpvz4g4/tL07HOo6TjunOvAIQCf69euHQD99XqAmwj+/Zbqnw3UUUjtt58TGkC5GoDdRpCNNmQkJJV7Vyakz2EDFUbBXQ/TjXlBGkOmYs2/yef3Y81acqyRLY41M1zVZ67pb+TgZzfqTfCP77eW9C5d0Ucbb9jH8ub4PhcARAgb02vmPmt3PMMkAgwzRg5DMCHpfIHVHenD2DroW25MSxGl7joJUK+RjjZ+dzruXOS78Iw1GrigBy3/z640QvpaE6ivIwHsB3YDe35U/esAcD0/X9prxtHPGvHMnXfsBFDIii8IYLUkRQSAOZIAki9uZcanBufglnQMGyh9013XWMULbZwE1Kgjhip/MubSeFAP1AAuNfC9+NQbDXxxj3FzPw/qwQlgAqP5YEAPUwMg8GNeSAMQBLBasC93PQ0J0CbAyYC7C2tT0hC2EBrObVxrESXvCgmQupiKOv8DGv3MgB6tfD0/9v64PRfuvJu6vg9wd55sJB8CvyCArRla2AkAg4pIGEtAQ5KFRNWvcRL4zq7Fu6KRipfYGAmQmpi86DiqRl1znABibQYF9MAhQPLKfsDNOnBLLkjsMy3+9mg+pP5nIvqQ6l843xqwLNeT7obfkABQ65IM3IgEJiofwLjUbrUaMSuwMfDZ+aUSAaRjri/xKb+YS03H2iEZb2N8CHCpgS/tTV+vBu02jvGRBGjZ6tI8V/UXBLC5ZIf2AD4UUDHXJ6r48mHy69j5rVW8wbpKgBrG01jrT6PRT405DPTvT8faGPr7J9EAeHkfJHF57y0zVDd3P8UexorcS2RgNjxTJc2O/QUBbA4BmHLncQQmJQZoGJzi+w/A4pT0Q9hoiOjXtQGJwnaHBBZjraMmATTrahz9/B3c3z851gCLl6sh9boEmrUPHwc+EgAmSxOwgx+PBQFs9pCCCAA1Mk4AODug8d2H7knnrFYqhgG7A67r8xbU+/OAnujoE3PouLTXXN7bBCb490HqWo25FfcdPsVkBvNcogGYi3rye7sMEUyi+2o25V8n/l4fwiBCzmgA9ySMMpxZK0DffH1akChlV0hAi7Te5B5/SAA8pl8zQ/AnLyH46/juvOTmazawQjH9BAFsBxLLIwA0COJehKBOSmO7orGKl1gfCVBPkI44f1GPoq+/S1djGN3HwdLxFt7748496vU609nHNs+fCeiZYwMQBLAdCCB3KGZ6CSIJYN1oW3L69uvTkkQpO1oCWtR1JUsAlr9/vAXUK5a7Lwb34Nt2Zef5BQGsj7q+MYRh2gJMIjA9BI1EpWYSQNVFq7EKW8CORu0aK089gDbs/BkEvx5xGdj7mxoARvk1CUC9bvn647z/ZK05/TdVmWP8y6ic3AvQ1ALQI5Di8tO4n/4umpe0Em47A2+71o1WDWJehaHFfwybj5gRWCOIdvLt9PG1qOuvOAFEXVohAtDeaDAX+wgC2MFhyC0CyGgBlTyiMLWBndyORd3LkwBX/1IX2r5Lj7Ymdb6jj4P3/twDMO6E9GgTHwIIAtiuvfpq60VaAN5XOb+YkI5YTUcMBcrD0M69K6P+R5y/x8N8RR2aHiUCMNV/jPCLBkBc8MMX+yTs6r8YAmzM2H21oF7N9blagDYp/SdswdQWdm5rFjUvSwL44dOx+kk13gBqzNzOi0f7wbBfPMIvhvfaD8YtdCpB459pALRbmIuO/cVYfvsOFxKV1mxA1RtlNRxx086WAI37ktF9H8DYfurofu70w0N7c/C3AJICbu6B8f0Yd/yh6T27ddnu/581/HHjnyCAbUoAtmFAogbUOzXcPRh3HN7ZrVrUvmQJkMqXGtsfxH381Fi9xj3/MuBvAh7081IlwJ0qQQC7isxyhwHpRHUPNhwQS4VLxs+uuPDGZ6WaVLzxa1z9jzcauQTQACru7XdZ4gQA4+j6KzSAnTfmX8Y+kKjU0T07PVlzR+wmtCsgXdpLkPqvjbT/mLnkF3f0aWZZ9R97/wOgjlUCu07RfXH1Hwb6zFX/TVvAMo2sQM9JREL5rgJVgffdnu9nagHom5GaqjXU2zXfh62H2kZpLUlctSMlEO2WqrHixnDr73HPv5hLNef+cXsv0/iH6r9xpQrghiCA7Qng1ZFu4XeoZFqiWktN1cHiVN1/xjZB0aB2ZMMWlV6dBFikeQTn/k3ffwS/SQDm5p61AK9XAdy2E4AZA8A+A1COBlC4Ma5HgxZlrFa2uMNw6l4FpO5J/VbrEf4Aq4PRjruaf2A409AGkaY5Fm2B7Nx/lgDUy3UAN8zdfXD8b0zYEo8yYx8KCOCtFnjb43oeN9Cw4gQ8mL0hNe+41ryNK4xA23ZsStZ/iDR9EKJNwKKNTI/h+B8jAOECICc8Ha6F1GXc1rsaAP39rdh+NN+/kgaQWffP96xbGgVoezR+QVq4oxAGDsUdhtV7EmgT0k8hnrapHWBb4mkJ/3R3dy+ZSy10bsmNm3SCxv8QafldiLQARJpVFm1m6Alorv93wkLMDPqp36kEO9gFAew+0uAEMCVpGCdAm5K2nR2gEHYKndsk+Cz/GKoY5r29vvcoivIPbVrAdtEGeD1YpO2vYaQVIOLQ+DAgQwAt8Cx+wIz3j9t629T99SKAfA1BaARbRyz4LVQkAJ5XfgFb+DbSAHhbJTwhpuwYWx6Nm/trRj3p7fV80KME7sqyT1OUPlWWfVNut+dnTcEu1Q42t5rm03D+n420fQ1G2gGGXQaLOmwaAAYAMQlgozQAQQBbB/ilZIvDgEodpwPVyZrb2wX8BHRZ9v2cLPdxPCGmEE8eT98HLdxkcLcVOKJncpbCP9w9vo8rSh8ocmBJcru9H8Br6MXo5k3OeV0Xzzi7WKQ9yQlgxMXyCQADgBg36sEYr7FcWe0Gv0LHuQ06H+Ar/b20UeaWJ37fSHlUMm2ymvFYDVOVT57ckFqtNplp15vcRjMYQczkY8mrhMDnDYLP4/+4rV5bU1c7mE9+2h0KBl8E2e2D3h6fpsgBhkl2+9OKHALZHRyxVXhLDondkyPN/5RFWgFG2hhwAnBC1gbQAvq1ZmC3GgAm6gQB7BjHnjJJIoHBWWuJAJg6Lv0INk5qK1vSUK2HKrI/ggRgYsjEk7u3T/N6AnAq/IfQe1IJUf3sWKRzG5rbH+ju9f4pgv/Tn+7VZdlnIEsRAZg5/h2c7u7ubtjQSq1QOM0AqDHnb3ACGG7TkQQYxgGw2QDYdQfA7SZBALsd/Ph+GQKoNXAnofSU9CvYjKitrNCkNuznT35SaZTdgUeWBsA7U8RSn+8UagBGb49HRxLwegN/SpWwY5LObVSeUTl8vuBfotrf2+PRfN4gs4YAmQrLbr/BNQA5+M3u7u59G1WhUsolL690tKUbQQ8jbeoSAhhtArjRAnCnURDAXiKARK1qbSX2X7AtUVsppV1txDWIFcXt/5alARjUoXqVEMMhQJ8vxDyKHzEHHiXwl7Y6ZLBpO7euh5kHKCd9X/B7T4FXCalYMez5McfKmn/jb+GUVzkFihx+GWuxmSyV/9ak1qVjjX+CHoAw0qblEABuAjLaAHDzQCb4J46/zYaRHfvT35SLMXqZ6vd2IBiuAdSBlqhW+UzApHQK2+x7CWoAACAASURBVM1WagCEEY/S90eo7ns9gZSVYwfLsYWagIUzFX9TFB+fwbDafAaj+RhYj7954e6TfaGXwi/Dyd9XNDv4c49PqQh+rxy+193t3TYbM6bjjYOcAIY7dBjpsIYATcB3ARo7AHCrFsDa7FMQwA4GdykEQ0OARDWfCtSmpFc2A0QrAJFjrKenp8Pr8d+zwI9A5xq2hTHe4cpuP8PZgXDoD+DkSTfZBDaGAD70oQ/xrZXdPd7fRvArPX261817e97z28HvkYMagt+jhEd7e3td+MLEbCu8/Ib/rMYbL2UJoBNMG4AggD2pyWQJQEcNQJuUIhveAEt4AGEFseNVAnEkAVT5kQRI00a8+bxhtAmwnpOKzo3wct8nsHjCagmPKu2S7u5uvoLOK4d/oc8TRvAzT6/fwGM7I+GxCf4Qgh/HJpyN1r1CpVV7yVVfPyPVpePNf2MRgAEjpRCAOQwgpyBS/Snfk8AppXfdCddkhwCcANQp6dZWqv/2BmvHDI7zMySQP9w2hwkGHx7gsRz+BSyHMGsvs6xjYiPPC6Hv8inhuT7lRVB6ArpPPgV9yovWeN8c/3uVkI4M5VFCf0QPo/vp763M75+X6tV48wNOABc7DBhejgBqTCux5dMvgL4LhwMJ/MZ1oE1WG6gBpKek/4mdxFa2Ufuz7djJ2ARMjC3RBBQ5wLHnlUPzbrf/XViO/X57uas5pvFEhU8Ove5DQ587rCH4ffIpholUkmzPvz3Bjy89fVpqVGPNj00NoM2A4XYwXYELDQEEAex60ssngLvS3799QzqwGoBs9LV2ECuK/2XewfIhdtbwTsNvwqBXDl6z1YswbDtV4iGpIT45oCD4fUpItYPfRgA4EwAeOfglKtpecTq31TkngHjLPCcA7gjUKghgJ6jqG1XHPAJQ70qPHk5JW+qvUggjdix5lOB/tzpdjjnbENzqjC3juxKUsSzCcKFylz1HN/rk4E9a4Gc+NDxYPb+VI+hxJgDV/owBxV7hZR+yyT+aGoCTEwCLuBg6BPE9AWJCA9j1vX0hEskSADMXBEmPpy9JjZvcLEt6nB1TiDWbJmC3wzGvglq5qZl7ev3/BAsnLJf0IPtFH/nIR2q87vC41evzcb+NAHAYoFvOCn/T3d3dgvfaK2ovazscT59ubdQjNgKwvAD1ZQhgTwKjEFh247l8ArgrzW9XArBjy+12O2S3/28Qe2R3y2oC6H9zSrdm4cbLMgYSY3iVwH+zwJ+v+qMtwMDfFDmgut2+92MF6b7tAPZCdTAJwJXVAAQBbNPY/ZtkcNxhBGDHGGIOsWdpAtwF3yQBrgEgCXA/HFn2/1f7fYVwkX+OGw3c7sBxrxJ8giC3wJ6j/pMxUHH7/z0WUBbT5D95g/9GAmAjrnmu+uMyYEEAggDMWQBzCLDNNQCCB2ENsWcbClgzcuYQwCOHDdML1//E7XYft+5d2SBIvbhPDv0xH/vLpwr1/nwmwOsOv1ZywVT75fMKfL5Vh5Uru3xZS341CaBNEMBuVOfLeafN0wA2ol1zfHiU4GkbCWDPT3YArgXwIbrs/xyCgbC9BBh0gsbv3p7g+3B8b6n/9p6ftAHwyeHHshw8ivfSfVROOXmhMgqdK6dsugdOtzbCsCAAYdewhhibQACF2nChc9RGS82pjJMnfcc8cnAuOxTgNgAiAeZ149R9SEdMY9l0X8Hn0I8+d/jPLdU/Z87ffs7bG/6YVSD3EixYYGknMz29LMvvdbv9H3W7Ax/BEEil3V76VUQAGAwEZwHEEGCTxtrl9M6bcc8mEAC2TmzLPk/gIz7F/9G8dp1p+6W34uyVmaGAEvxYVgvIIQDw9AY1JAGPO/hFvJMwni3FOqIflBcC/9DrDqcL9f6kFXjlUzfJzXdJQas4Qc/EW7xKoNej+MmYgdOLhtvd9+lVFLfipYIA9jjg80llEwjA4/G/gP76fb4QLuMFnzes+zwhNzVWOwboXBl5hVcO3UISoBmAzFDAHeJagKc3mO7t9X03ll3wmTQ+8LrDIVtPb1f/8ZgPC8jfmO4po8L2SlR4PIFXrFVP3K+AfAtw/OJ2+z6C5a/lWVQ/QQCCAHKGPxtEANRWPdjrYwgvM+H6fc1cwBMGbPPUiRYEJDXaFXJ6ltIb/Bc2ArAPAVhWCwgEi2GJqyK4+sjnDt+3CACn+YgA+Jw/Py8Ho1adylZf6IWx8h6P/ywHvxJSsden+UwiAa8cWrfNG8shAIrpl9Nw8nsS8ffOnE3YIAIgfHg8gXFSzVELwOT1hAyfN6wiEXg9obOEBcpXwHuxnzkWPUooZjnt6eS853WHkAAMPgzoDd7v7vY7qX6ZwohFvL3h3yjW+9O8v6c3+PN4I92TKaT0gwxxeOTQa1bPnxNUhEjAZLTgDIZIKr344lcKAhAaQA6RbyABKIrS6FECs2Yb5pF8OAFYGgAu5eUk4PH4aSYNG24GG8Vb8dJfCIuy7P8FGwFwz10kAIsEuC3A1xP6d1gC3ZNTmk8OR5AASNW3jjN/e93h6zk3lPEHMZ3XHTyFwvF5g6rJjri2OYyCsdY5h82VhXLwbsHKlvFsQQCCADaLANBA51ECX7UIQLeGAfb2zUnA1H79PBIRYaOMpp25xasE37CRAM4AUNLx2NcbXhKgl7NOb++p7y5i/GPk9OPtDf8/+KRyAUn3edyBX8sKJgP4pcLBAKNK4HfW8syMZCRJEgQgCGAzCCDTzj3+/2q1c6uTQ3tATieHzjs6koCi+P/vtbTzzDPlwG8iAXjloIZrd0gDwLyvNwS+nnBaeSH4DyxcVKAxjk/jeXpDnyik/pPq73WHH/b2htsyN9qRVcIxsVtvb9+7PXLoGQoGx/xcJfK8yHxm4jEG+pQXdZ/nRQwq8uclFF3yJYIABAFsBgHYGySukKXODoe2tiEAP7ZsAuD1hhY8ntB34b2EFXs5JRzzjtzb7W33KcFpiwSMvl4OfAQ/8/UENX/PKfC/EObboBH2edk++dSFAup/pvf3ucN/gheWWTm8lVfQI4fOW+Dnqwgt4CMBAD+WTxkYdMSrhPt4xcz/yhob2e7nh4IABAFsIgFk2qwih/psHV4uCXiwrZ/SePtXTp2z2mzm3vw2vNzfhE2vO/CnpAVYBABm728RwMnw+ZxylG7lkFcOc79/m+WfzwCQBoDTDHgTqRo5BazwB93j8fh+2QZ+7rtsU4lQMDqGGeuz1jJbxZYljEJVEgQgCGATCQCbYKbtepWgjG2f+wFkhwGk+eK0HScBrxz6JbyRMFOoHRc7R/d4Zf//RhoAj9uJsTvdAa4FIBH09YTme3oCBzPl+HrD/4el/tun/rD35yv+vPKpd2RZXtP+6Xxpscc/hUKwL2Eko5/XEzLnSJVQZrMDuwAzlV3DgSAAQQCbTADYWjMk4JGDf2ZN/5E/ABEAar982OvzhCcRK2to5lJ3d6DFJwfvIwlg7E47Cfh6gjgsAO/J0L/MPMPrDnss9R8X/mDPj2oJeOQwj+7rlcP/w7o48zKZm1c4IFbyuPv+Lbd4WsYJHlwEx0RmpCE+b+lVgt/ZoNG0SZA6s0Lxq/q5HALIaTBivn9nzvcX+24bOA1ob5jUlrFtez0v3raGuxbgM/YvUwvASL9K6P/C+wk79rJKOOYYVZS+V3CjHssYiGViQrypXDtQgp5MWV53eCR//I+uhEQAihJe85JfrydwDQnAp4QyTgp2EvDKQUM56f+BNbx45n2KHQgCEBpADqFvEgHY27SinPoBMnjb7F9kA9NNo3joarE2vNJ56kAVxfsxGwFQR2vDX3CYl6V8Umn0KS8+yBsCoAaAjMRzAiYx2UqVoN/pek9v4Md57+8JcOeEXOD7NZ8SAJ/s526K9AJUxnrmggAEAWwVAWA7ph7d6w2HMkMBMn7TTJjlByPLoR/DewhDpeKArne7fT+I+wig/wHfT8AMH45bihm8I/YE76OzkuR2h7/fJ5/iroKk/mNOAQU8yql3PvEJb32pFbBfRy+sKIE+fCjuYpIL/qDBwa8EHp886T9s3bvqYYb9mcsdCwIQBLCVBED2AEUJd3k94TlOAsopIzMD5nkRXYW5fcDjCfuwLROGlmvXhX7DzXg9SuA+EoAFekadMO7i7fMGdU+P5/skjzv4Ib/3JYz1j9NvfOWQfNLPFDmkh4Mvox3gYqEHlHoOe/SeHs9UwH8KCcCwxiJ8PELjE/QKxPLKfdlS61IWAXA10QwRjrvJLknFxpfi/Pa3F2ziEIDaKLVxnyf0okUAaP2nIQB63fJpcDQG0rV072pzjxIc5kMKbxhjd+K+nYAGQfmkz8B9PZXewP8pKe7gpywCUIkAlJ4AKHJIRQLwKqGX8MFlVIb35LLs/17Z7dNxKSTuXmLTADLjEkXx/xA+g9SX1b5oqdcLAhAawBZrAJk27u0N/jAHZ94QADGIfjA4XejtCX2P1bZXpRUTVj1y6A8sAlAR/EQASk+fygnA3fcpydsTfAkJwNMbRALgfsNKT4DJ7qCGBKC4C3gNlYA4qoSieH8dwY8kwH3+s9ZIsvxj5NLKEopc8yWCAAQBbDUBUCPGNu/zhCdQ/feawwCuBVgEwI2BHk/41/B6whLdu1JOdjSPHPgE1zI8Ic2mAeDWfmrQ9yJ4evtelDzu0GsWAeikAXh6g0gABhKAXKZjAlValvsCqP739nj46qf86QifXHyN8kovutrfBQEIAtgOBEDY8HlCYWv8r1o5usJjslYKhvzYxun6Uts7Xe9xB37ZIgDDRgC4r6eOGoDH7f+y5HWfumL1/Bjsg/sAIAHQLIDbHfgAPrjcXtrj9g2goQ/X93OnH2tbMYpc4pGDv1rOS5YqDPt15RCANlkDmJaM/ckeIMb623+sX+wbbYENwN7Wcb7fNv3OsYcYpMV3PvepAXv7LfWYsKr09P00etbaht38mAjAJ4cuS153eAoJAIMGWJXBYQCfAkQ/AFnu+0f4YCq01ErgdchEPtl/CwnA8v7LvqTyEnjkF43e3uAPl1v+auqC1woCEBrAdtAACEuK0vcj1Onm5WZAXnf4FvXmq2nrVL6nJ/B9PiWEM29EAphz70BODHJwUvLK4W/bfADQCmkjgFNJtzvwnPXwVRki8J6Pf/zj+32K/1uWBsDj/Vkkw7zKS+BVXlzEKZFyy1+NUPBaQQCCALYDAdB04MmTfUd8cniRMGHlmcjbXjn8ze7u7n2rbedUvucFz/M+JZQqSgBK8FuSVz7FnYBsDIQkYGkAp56tZX4e5yK9cmB2GQJ4jI5IZbxgWbcIAhAEsE0IgLff7u7uJq8cnCtGAD45PIMYKqOx885a6Va6vHLoWT4BWEMCwPUCaAN4lF8BIgCvEl7o7vZ0WhVYtQbAvQzlwLw1BOC7l+KzcJERagAe+cVH3jKdjMoQitAAio2F9+r5LbIBUNtFcPuU4AwCFF3hMfe7T2Ey1+PIp+bK7CCJAA553aee2fFN5fO8N/wQbQAP7RfQsbkYaF00gEdFNQD5xXnbKsNVEwwJstRcaABCA9gmGgBv6+aqvdC8vYdGYPb1mqtwfXJ4ukwvXF5+oSGGnQD63KceoA3gm9QrY44GQdIAfJ5TKbfb/y4LYKsGKI5ffHLgrT5PMMNwtL7A1ABeQhtD6fuWlYr0IteVRQBTVYCRgXMazl7tMXfbe2+dBsCxhPY1rxxK2gmAsMhn5uTw367NBhD6Lp8cTvFOPbvyNoNFnxx8C20Ad+mhRAA4C6DIIb5Guacn8H2IJ7IsFsFWwdN4j1cOXOcE4A6g409mgZFFBCDLwZ8st/yCD13mpCAAQWQ5RL5FBEBY8rq9H7DAn7XS82nAEPrk4PZ7r5NBb5lmveQnKt/96T5c52POKBQgAK8cmpLkF/rGTgVeRss/Rg3lbojoB4AJK6H09P0v+AQqdMnTip/gLCfLvlfRE9Dd66WAH/xlaR2A4g591Cp/rVuMFa+J9Us5BJDTYHZbD7jX32frCMCMwykHfjMvQhbXwJWegNbnfQlkd/Cvraa7Ku2bsOp2B/5ZOPgZdAFmvT2+zFoArzugnwp+BtwveEeRAL6STwDcFfik34zN1+P/FazEaucjyR1RUfpkiwDMyKjmnGQmUIFHDv0xlk+Vtl54QzJBAEIDyCH0rSMA7vrulYOftxEA+sogATClJ6ByApCDfAsxwlKpoCCsut2Bf2MRgG4nAE+vX0MCkF/wvir1vtD3okUAKsYNt9yCUQNQ+SIhXDDwnX/lV8L3y/6+MGoAfC2AFRKMWbsAgdfj/9uPf9y/v9SXW8t15RNABRiTxZIAVQ6odpJWsUUEYOHpgEcOvmURAO2IxQPjunsDht/3B+B2B34ZryVAl9r2CauKO/A7FgGovT0ehgFCrKSGQ38APT2esNR7su8TSADW/mE0BMgsDvL0Bj5jVXi1C3a42oLOCH2+cNLd6zUDE3A7ANoCQiYJmHECfq6cFy1VIHSdIABBVjlktQUEQGD29IY+mAd+M0iu50VchwM+DzeQl+WER9q0LAdfRgKQ3X6tt8dD4GcYlwMJ4ORJ+T9JHvepD9mMgJwAuCuw2zREeN2BOAGo3Ly3x3MNFwQpSh/f7cemBZjRgBS+UeKGDwMEAQgC2GoCIHB65dBfWQSA4fG5j4yFC1y7Dz5P+WHBCKeK2z9KZWaiAlHHiy7B7uC/knDNcWbxAQUEtTYURGLw9AYeyp8qLyIwsV1vr+f3cBiAzGPb989kPFwnIPsNHp3kOzUnAdFLrGcuCEAQwFYSALVtt7vv+zNDYJtGbGnFuHQX7QG/i22fMLQKHFjGd7lZkf3TFslgGDAzIpBFNrg4T5b975XQEw/Dftu1ADwm12CvO4Ak8ONYAXqBUitD1+ODOPgxLlnuCyP4uRbglc1NEumeUp+xmusEAQgC2A4EwDfFNXfG4pvjLMGEElJ7e33vwba9WjzQ9bLs+wmLSEzMUUxAcwduNMK/nXEyUnoC57jjgTtkzhnSkl13WEMCUHr8S7cSKh15JiO5vYM8PpkczHlpnxJgqAFwb0F337/GYstgvZJqIwhAEMBWEQC1aY87+K8zvXJeZ4i9MlfZ5dCg1aBXNf2H95ABUO4NfAIJwCqT4gEiGZib7iqhsxnQuF8InESLv9cdyuwLgA4KNFfvdfv7y60Qvbjb7flZiwDI4smHADZhYGXv23YsWfXLZ16oyEE5BIBegNpUsRkAPC9AtWNlsHlGQN6We3p6DnqU0Dv2Nm/v/WlY4HH7fxabMGGnSHMudpo/yyuHBq3nUIdL2reK5xV36GSmAPmk/xdQA8CYAGgA5Oo/spO1QMHb65/p7e0te2NQ8mbyeYKRvEplSMCrhKyKBbrX8PKZdyp0IAhAkFUOWW0SARCQZdn3+9j+qa3bwE89NXa6tH13OR0gv6e729vuVYIzFtZyOtwMyfQGfz6DEV+3r9XTE5jJsQOYroMYuJPH7vO4fWXNSeJDaFzi8fj/iSUAAn4mJ/XHIwe/bFWsHAFk3qnQgSAAQQBbQQDUASqK7yu2DjDT9u1EIMvBn8C2S5gp1I6LnSOiUZTAv7Fwhup+5jkZ8MuhR729vS4qhwNNPukfNO0AYY0bAfM99tx9r+AN5VTMfp9HDn7GEkLaRgYZVsT90+zX4/F6/RMEIAhgKwiAMKMovi9YbZ5ruxY4sffnWPAowT/Etk7Xr7bd030ej/+vLYzZ1f+MluFRghRqrCIzzlBO+v9fSwNAAlgavlsOPPWd9B2zKlVO72ypJ+Emrzf8t2a44lDKMkqgQEwfAbe5aSGx2WqFsNz15ROAuSLQtAfkHuc0KGEP2Fk2kU0eArjd3n9pEQC2dbPNewIpc8MOP678a1orvk6e9B3zevwL1Lna4gHikJ537h45/Jv4HMIYByYuy80JHpAdApg34ny95RZMNy4HtkK/0X1mTPTQPI9Yao6JUAMAjxwKr0EAhR6Zc04QgNAAcgh7kwjA3qaxjVvg5G0ewe9R/HO9vV4eG5MwktNwS/iD7vPI/v/CyzRnFJZ05IjxQkvwOQmg5TCjBSxZPsj373vzt37rt+pKqE/RS0hN4WuhlUDA4/Gf9yr+/+Hx9H2o6E3r9IMgAEEAW0gAmVYsy/5f9HgCr2Db98h+P8XdJGxkLlzlAWLTowS+ZhGAGYPTCghKM3q2SMNZLZ7YwyuHfomP/3ENsU0DMI9xPX8AfL2BD2O96J5V1pFfvsyLZitVTsEr3CMIQBDANiCAgm18GUys0KqzWPTIfb9qDicCGeOfDcfmRjw9oV/CAgvilwfxVELfsHwAaB8/2sLLLEAJrNdOPhW2StiPV3zhci8QBCAIYBsQAIGPE4GFgYKksJp2jgTiUfwTVoARjlUOfisGp6nZn/pG0SCjBEavO9BtcwLKGUOYakQAPO6+srYsWs0LbcS1ggAEAWwHAljPtk24VRT/r/PeHw19du3dttGI1x1a1seGs5AsB496leATi0nsBIBOCtxl16v47UyyZvZaT4EsV5YgAEEAu4wAOPYURWn0KIFvWgRg19xxlyG+4Y9XDj9BbFv4KIxZYhOfHArbtACKV8aHApnFO0pQxsLonuWAt11+EwQgCGA3EQBhz6sEZG74U3BhXWYXIBOvbtOvx+sOh0rBK2cG7wveE14luGCRADKKXROwiCBo+Nyh95dS6I4mAGtvQNojMD/PaVDCD0D4AWxSYyfwu92+9/OlvuZ0ehanpupv8DDj7vBCoam/glWlgn1yQLHYRM1nFXIP9irBN2zWy8JqRcGnbM3JsjQAQQA7C9SrIeHN9QNYz0ZPWKvwKP43uOpvOdJlOmtzRa9q7jMQUvDhhO2VKsIL7+72O31y8G2bFpA3FODGBvBaQwEbEaxU/pb9LghADAFyNLYdSgCENa/Sl1H98zz/MvsL+nvDb7vdbocFOiKO5TFITOGVg79hEcASy6LlLozeTLq3J/g+LJEqtnzpW/erIABBADudAAhj3h7v+7yegG71/pkFP6QBUJSvvt7wbyDiCNOrRh8uT7SRgBUp6CXmk1/CY76owSOHPokFUzCCVT9kk24QBCAIYBcQAN9TQFH6PoXg9ykhc4huhvMz9xTMGv5oafHqEUZMg+G8aIthc0oBgc8JAElAxR1+FLe5hl8QgABYDsBWMx7fimt34BCAMOaR/b9vIwAzhofN6Qe3BJM/7X8vIp+wvGoWILXBqwQ/xrUAdzjtdb9oIAFYOScAWQ78cyycrl/1gzbpBqEBCILKIagdSACEMcQcEQD3z7Gs/l53OM29/nrDH1svTHLDgVcOvookYK4V4FoAP/Yop2ht8SbBuPzHCAIQBLDTCcDe+r2Kf5BjMoNLHswXvHL4Veu60ox+9kILHPNCcKWRVwm+hB5FuOEg5l45/HImsqgkrcvDCjx/3U4JAhAEsEsIgGMNseeVgy/75NBTPjUvh+YRo7YVu+uGyUxB3m5vu6cn8I893Z5OGzIzv9vObbtDQQCCAHYJASC2MphDLCImEZs20GV+t51b02FFvjHB+nvdH7SmWi5z80YQQH6UoJwGVoZhK7+8lf5e6/P29P2JGtAm60CbrGapu1WQuifNT1+SGpdpQtvtpy3BJD10xwCfvlohAmDRFsCkx1ogPXYA4FYtQKIKDN44sIGUkHjocDNU2FoBtRLg839f6/P29P0WAahTtSx1twZSdyt3GgFQ096xmKQX2JQ8nwBY1AkQaeFJjzohPdoA7HYtd31Vp2oAE/YQRqJ4yicIJI61pPzyxN8lEHApJF3wmjrQEvtBnTzAUlN1kJzasQSwKfjZ8Q9ZSgAI/iaAaFNGA8gSQBUnAAQ/TBROJjEsBTwkaqCctBbiEPcu/Q4rywSJfT9oiX2cANKTggB2PMiXe4GCBBA9ABA9AHq8AdJjtcBuV4IxWQEqqvWTNSb4x+sACiUkhkJgn8D7ykiFyhLnCst4neRijNeAPlHJ0pMVkE7sOBvAcs1d/JYvgXwCwHE/izWAHj8AKieAfXwIgKA2e/f9AOP1ALcbiyf83Z7u1AOsJdnLEse5st0AeRg360C7VcvSd6ogdUsQQD5mdtXfSwgg6gQ13sJTOt4KyVEnJC/tg8XLtbB4eR8sXjoAybEGbhtA+0CxlBzD6w5wIyIaEteaqDyRm3LdODk0gH7ZCdoVB1Nfbwb1WuNONQLuKpxu2MuYBNAxDyPtoEcdTI05IR1vMYEfb4ckkgACHkE82sR/S8fxGifgtQVTvMW6ziQSIpS15FgnkTZeBviN9LgL9LiTaZdcoF1yzMPpHTUNuGFY2ZUFLyEABP9Yg5mw9x81pwLVURwSNGW0AzuYcdhgT+ZveK2Z9BgaFMtPVI7IszLdSFmY37KRGaONYIzWCwLYlci3Xmr6dGsjXDg4DyOdoEddjPf+GQIwexy0BZipZUmPj1OFOckig+UIwk4WpRzbyxLH66dVLSdLPdbIIN4MEG8UBLAnCODiIVCjbYzUe3uOan4W5K2gR3MTi7RCJuUTgvjbJju7HLfnsTkExKGdi2GnAMMd89NiCLB7KYBrABc75mG4E9RoB0vH2kGNtfKERkA8zgd8/t8Z8FtEkCULauQrl5FfZu7fVE6p+Vqft3fvx+/Nv3u0jcHwIUDtENvI7kXAHn8zkwDa5mG4HfTIQZaOoiaQJQFBAHuLDPDbp2NmZ4CGYbjYJghgN3MEJ4Bh5zyMtIIe6WBqFD++IIBcDWTvkEAuAbQCjDjFEGCXEgBfuLQwXN8Bwy0LMOIEFnExUv/t+Upg2PghAAFQDAFW+hZr+x3lS8M+F4MIXxfy5Mmw5LIwsOMWu+1S7K79tbq7pUosRY0ceD9EGnVcAMSiDmaO381GQCSwUqMSBEAEtdNzIthW3hbMVaGNanq49j2CANaOuW1VArwiVWGF9EjdB1nsALBoI0MCQDCvBPiVf6eGRPl6lIllUHkr5ev1vL1VTpbI27k2yNtElUrqnAAAGK1JREFUrAG04bqfwbYCVqexrRqyqEx5EoBuiYdS1mL7P4l+/3q8XkVPwJXBXQoo8gFayj2lXJNfbrG/SylLXJP/rU0CaAc20skJQI82arggzIjW/0eLAHibKa/Fibu2mwT4eC4dqx/gXn6xeg0dQ/IbBf5NPUP+b8WHCMWAWex8uWBc7/LKrcduug9ng9ApDF3DmzX04GSR5nUNqLndgLAX68PBv3h+/xE11rRgLuhpZGq8ma8FyAe6IIDdBPBS3gXB38a4RoirQyOOuWfnDhy0gCIMgTudMaJRU/1Pxxs/hQt81FijxsGfIYDcnnUlAiBNgPLSx+r0nFIaZaFr6P78vNC14lw+sS//t4uha7gedWh4nTri5MMAajs7HQN7uf6cwR9HpZZUvPHbnADizYbdLzwfwIIA9jB5RFyGSRSutx6+IjUILWCHUwcZ/1LxRp+5vBd7f1xg0syIBLYfAaBKiikfiPk9P/2df534e6nsSpEJagB4nYtrAVrE1YvNn9rQDofC3qv+jc9KNfjWqVjzz3Dwj+K43xr7W0FATEMgAcnMt14DEARQHoBLAfly19AwgIigFbSLrR/ANkRtae+haIe+MX2wJ8Ot707Hmh/x9eSxRh1zPdbMcpbl5s23CwJYDiS77zeMDJ1NDsaPIw4dcz3Sej95vvmEIIGdQwQVpLKlhlvfvTjq+iau+TcNfxhgojEX/Lie30YA5sfPTgUSGWBerFfKNh57Q1rm2L6ceDXHOQ3VVv5qyhDXZqZ5M992iVwtEuAGQSek4o6/IRKImv4kYmZgG/JBhd1iC8POn9Fjzkf6qAP0eJOmjzaDEW9iZnKAEXcAxMxEG4NgbvqDo0/4MmkEF42UkZYrU/y2vMw3Uj5LviXGBnBZXqIODWNFpGLO+9pwy09Tu7famiACEsgm59/ZBUWqxJT/IWYvSs1avNmHgOfJAr8+2sTMhOcdPCEJYKLhQJYIzN61IAksaSz5RNAOfFkpLi3lKe/3jWzIouyySCSjCeRoR6Y9AKd60zGTBDB4iDbikPMChlRAVKpGt2Ew9+oTpLCOZMB7dVrIs1y5i3HnEW3M8Sn9Ssu39SstoF9pZvrlZj1zzP928giwGAWWR4LlQSBdGUJYGvAzd5EQzfvz5cO4hLhowiXG1jJj+zVW4JFMOeLvTDCWrZSJMdoBhZI21s4wqZc6IHWpXVcvmcfpSx1vpS4d/PizS62HlmuT+Bu23VfMdSiCGFYSFv1OvTv9jTkK8WG0rQHX8z+93ND+7Frr+59davvg4tX2T6auOQfVa44FDOusX2sE/WqDpl9rYPyY53SMv5tJu9oEmNQrjTylLtdD6lJjNkAoxQlckjdBcmyZNIoRhm1pybVWANIl5YrzmeCsmywb7UoLFErpqy2QvtrMUtcwtQDmi9eatcXXWwBT+ppzPn3V+WXj9ZaPa9ea/1e43vBeeF1yQVRqgKi0z95+8bhQu86/Zq//zVV7EgJEpeMwUvNRiLq+CLHOWzDa9ggutc6zy21P1autevqGC9I3myF18wCoN/aB+kadpt2oM7Qb+0C7UcfMhMeUakG7YSbcDAKTfnsfT8ad/WDgzj8T+1dOK25O0Qgwjilvw5BSyhbXrCz/dZaRdqsGCqX07RrIpmqWuoOpBlJ3qo3U7WotPV4L2p1a0K0Et2tVuFP5FCakWRiXvgEJ6RJMSJ+FcelX4brUSe1aaAQkCVtuCYWfUYddPwgjzX8BsbpnEN0HEHEBRDsAxtoALjuAXW0G9fVGSN/ax9K3qtX0rWpNu13JzFQF2RyP81MFaLfNpN+pBJ4mqkBPVPANQbM75eLfxVJV3rV5f9PmoEu2Bi9WnjhfXNYbLxttQoJCKZ2QcKuwTEpOSsxKQMfpcUnTJyTNGK9kxngVwLgEkCiQxqXHMCF9Hsal76FmX8rQlq7d1TmBH1X8ZLz9D3E8iFNz5vSaQ2NRh8birTq70moY1xuZdqOKqbckpo9nEuh3KhiMVzLgHwE/RLFUAcZEbsKtwCFRkUm8MU5JYBRKRUmBGmoeGeRfX6hMca6wrLdYLtqUBPak3pXAlpg2JTHcqh33FeQEMCExPSExI1FtmEnSjUlJhSlJhykJMBlTkp6ekrxfPyPVIaip7e9qgC/3cta8qjQb7/je+UutX18cw114HEzlc7CWZ9ZoM2iXG1j6Wj1DdV69JYE2LoE+YSU8RuYdrygpGRMS2JMd/HhcsDeyN8Z8UC/5m0igSFlLrt+E6+z1x+PV1mG33Z//PgX+toMfj23gB/VuBWhTmJAAqgB7f9QiMeF28tpkLdOmKpEkEPSMp0lJ0ywSWbwnjc9PSe9CbNinr5fDyq77jdhvMdb4o8nRpqeWu65quuui846DqWMNTL1aA+qNCjBuoTpfwcGOKpueMBOBOR/Ixf/GHj+bsmo/AbdQvhqQFrp/q8/l13+19dlt9+e/T/G/TaAT4Jfm2fZjloGkYCarTCIAiwy0SUnFMtWpyml1Svp+BDZhYdeBvNgLUYiuhbjje9PxpqcYiYVH6eG78pg++0gIqcv7OfjZHbPXxp4egb+hBLDmMfxqwbXK66l+K+VFbRArPI/K3bX3Fwd7Ic1oZQLILY+uX1qWxIxJTBVgJCSV51PSdCohPY842UshyPic6MOo1LAYb/0634kn1qya++kh+OsZ7cKrXt0P2s1Ky7iCY/elBJDRBEpWa9cKgNwPvvRDr1D+EmCt8noC6Er5kudQvVd4HpW7a+8nOZSWE6CL5Uu//3LlFiSBW3DDXLgmmc5ExfrN3XGerJ/JuOMPcTdeNeZSuZ99DJfoNprgx+22L+0D7VotsNuVWQOdIAAwCKAr5bsWwGslsOUAuvS3YsCn86sjACw/jwTQ2DgpyYjuXT8UIPAvjuz/Ie4wE3cx3KKLb9IRc/E1+nxr7rFawLG/caPaNOzZrPTU41O+9ANQA1n6Mc1r6fciOQGrKICKlUvni5S7pLwyr6P6rZQveV6J9aNyd+39JIetzIkEJAaTEh8SpG+Z4cgJI7uju897C3q59Oj+v+BGv5hLU6OHQB85zLhrbdzcnlu7UgPsZg3ARI1lsMtO0xHwKRcEUFNYK9i1AF6BOFcksK0Evv3Zpj0AJtAeUAXqxL6XES6EkTzo7Io/+dg/Gd13PD22/xknANQAIkeYPnLU9J+Pt4B2uR7Yjf0A40gAuXP0aNkn4FMuCEAQQNYSX5Ulw6IEaAfhVh9LDBKSwQlgsnZ2YSrjMbj71g7QfGdqtO6j6PedjjdquC2zGjnM9JEuc3HNmAOM6w0Ad9Aldyn4BQHYGjj1dMXyogBYaw+60+/fatDbn1/JIFHJjESlrk5VgZqo+jB29bvSFkCqTXq0/ou4oCYda9bMFXitmQ06USso1Pvn9vIrNMAlDZ+utwvefky/izynJy0qRyGn9ZQTJKqRAEzfgEnps7uWAOjFFuPNt5KjTiQAnWLzIxHgPu04/WeO/bO9fy74EbjlNkA76O3H5ZYn7iv/WwjZkeyQAGCiUkfXc3VKGtsVg/1iL2HO/TsemdN/DgPj89E6fIy8kk8AS8EvCIAajsh3B4ngEADtAHw2YEr6xlsFlhIXw9OOO4/RVNJx17xFADw+n50A0DZg3Moa/wQB7I5GLsiq+Hc03dItApiUZh9OZfYj2HH4XrHCJgE451Hdp62YViKApQ4XxYXJGxoZxZYMFUjtX+H+JfeJ6wWAN7ANYHudrDT9Aaak+elLUuOKQNqpF2QJwMnDc2McPlz6a9oAnDwiD9cAEihwE7CCADaw8QmyW4NNaZ2+iyCA4gRA4MecCGHF3khoAFvfqAWxlP4N9hoBqDEcApgaAEbkLTgEsDQAQQDr1MsIQJYOyM2W1V4iADgtNarxlnm+WQftzxdbrQZg1wbyjwVgVtSQNruBi+ctTz5cY61m6ORm7HYbABKAHttIAkBCECQgZLBD2gAHfx0Y6AuwlwgA9+hLx5uZuW3XemoAggAE+HcI+LGj2osEwCIt84IAdlAjFRrVxmmV+QQwucunAeF0ayOLNNkIwOz9i00DFjYC5o/78/9eAVxc6LYVdKKBr6mBZ2PgmbHwMgFLhFxXlmuGAGoZOgQZe4UAMPwXrgPA2YDVzwLkAz7/b0EAmzkMEASwQntbjggFAQgC2Cyw5gN13f6erAGtUMpEx6UouZaGQIAgTYz+3ov5XiUANY7xACwNIG76AqA2kFkLwNUhW8OZtFT2UhoJNayiOVpd7ck2HCh6zwZdk3kfuxZTQo9SRj0LgrQQcNfr3EoEkHn3Et53t16bwHUvGPtiH8Ohk7b7pwFbG/X4gfn02D5YHGtkGBcQhwPoEsyHAmONoGEcQN7A60BL7LdSPRgT9WAk9hdIdjAXOs69R0vUQ26iZ5SWF65D7jNKuwbrin7gfP43uztOJrpxEWBYsiESgwnc03Bpot8pNzeswE0rcpOaqIHyE1mybQSZB1a7HSfXo9NOeqs5LiKXvOdunGa1mroWujZbf/7d7jQDjDcxdaoOUncrd/daADQC6rGGOSSA5Fi9kRyrZyxWzyDayPjioNEmZrxRw8wgCfuYMXEgJyFT5qZaBhOlJPM+I4FMmy1XS+xjpaTMfdb9uXXIr1Pxv7Pl1OIWUgwXgWR2jqENJHjUWGwkGCkmT/Ohvy0S4A0Ie5EVUqacnPvNsnFnm7UkLDv7/OyGK6ZRiwBgxr/LRsTNBsU0t9jCbbZKTbjjzlamUutZ7Lps3Y1ELYPxBmaMNxmpqXpI3que2+WLgXAWoOUZbgSCJKCO7gOINQJEHADRdmCjDoDrtQC4Uy/trou9GzUyDBNmT7ZowehIUTTRPZkdgcxGW2ovYd9JiB9TeavNM8+36jopAa4D53vHWcfmmgcCPxKFpSlY4M3WxSqjlDpknpsLUA7SvL0S8/dOLOVvyGzLhlu0ZZOR4BFvGeUUxxFz0gwyW27dk0DFlLsHH9+GC7fiyiQMnbWVyV4XflyozvZztrrj9Tl1r4EU9vxT+yE12QipyQPPdjUBPHylrSEd6fg7TgKxhjkWOzAPseZ5GHHMQ6Rt3hhzzhvX6+bZrap54/a+ef3Ovnl9onLemJDmIWFLk9I8lJOsMnC6xZ5w7FUooWumPZX1zJXqedf2Lgl81326MdEIxngLM8adzBh3gTHuAGMcVUVr23E+bkS1v8YkS4yhuFIax0CrBdKdOoA1JIzglJuqgN2khL9VM3azkuE546ak6bcr5rU70rw6aab0lDSPSb0nzat3V0hTlfPqdkgr1bPY7wXqnrxXOY89P4I/OeH8O9wkd6eu9i2p3kgC06dbG3E4YCapEV2E8dz0JUzSnkvwValx9obUjFum3b9Y898fXGiEB+dbtftn2+H+UBu8M9QC7ww1wYOhA7Aw2gwLY/WwMFYHi5hG90MqXl9SWhyth/yEhtdyE4/gdBW3bF+a4IoL4HIbwCVMTg2utgBcrf8cNpLHt6WW/O8Ml6TGvZbyZbDrwV8SQ+zxi9456/jtB2cPw4MzJ9T7QyfY/YET8E7/UXjQ3wkPBpywEOuAhbiDkwCCORVrhnTUUVJKxRyQn3goNgzHVkZCw60x1rY0jXYAix8EiB0EiHYyiHZqEG8HGHX91h7/vOL1hQQKS4BCQT8YOvozD84egwdnjrP7Q8fY/f7n2Dv9x+GdgUPwzqATnsbb4OlYIzy9hBpADaRj9aBFG1dM6VgjFErolr2WZMQdUDi5AGJOBtE2BpF2gEgbQLTtJ/Dt6V0LS0KcFRLYmxLgm0G89ZXjLW8PnJiePv8c3O8/anACOP0cvNPfBe8MtsKTWLtNA9i/DQigGYx4oeQAiLUwiDgNiLgAIq3fhvMd9Xvz04q3FhIoTQKcBP7uy0deeXzhXfBO/2Ht4enngaf+Y/Bw4DDMXTgMi1FMHbAYcy1R/bWIAzAVGxbQ75RjSLZSErls51+b3/tDDIGPWkELwwTRFg2iDoBIy5+iCGh/iNLEIa4SEthDEiDV+O3Xjv3KzLnn4GF/l/7gtRPs4enn2MP+E/Bw4AjMDh2GheEjsBg5AovRg5CKtkE6ikRgJi3iAkz0d35Ov1POd2aOYpBWM7FIK2CivylXY7iT89LzRtwF9gQxVP0t9R+HADGnwUkh0vIv8FPSO+6hzypeVUhgdRLAGZF3Xuv41vRgF0z3nzCIAB70d8GjgYMwd+5gDgGkoi7AlA/2Qn8T8CkngFO+agKItYNhS+jPwcf9fOzfpuPfWsx178ZnpZrVSUFcLSSwByVAPeTbr7a98HjoODw6/bw5DOg/zh71H+EEMHumA55ePJTRAIgASiEBAj7lBHzK10IAJviJAHiu4Tk12vof8VPSu+3BzypeWUigZAlwO8C3X+k6PHf6uccz/e+CmdPPGzP9J9jMwBE2038QZgfbYf5sOyxcbOdDAJMA2vKGA2QHyNUMCPiUE/ApXy0BQLQTp/q4J2e29+dWf4P/HWn/Bmo01tvvvl1vS/6s4kIhgRIlQD3l/Fee//Ts6XfDzOl3qTP9zwESwOzAIZjp74DZwVaYP+uEZKSVq/9oC8i1B2w1ATh57w8jHXzun96pRBGIy4QE9rQEeE85/cetjbOvPf8WagGzr53QZ/uPwuzAYU4CjwbaYGbICQsXkQBM8BcmgFwioJ6fcur5KV+NBoDXQqSTJyPWCUasg5m9vlPj6zuGXbegW6rc019SvLyQQDkSoB7z0Vee/99nTxMBHGOz/agFHGQzg53waNDFtYBnw1tFAKjqmwSgxzuYGu8EPd7GjDha/5sBRlp+Et+d3qUcOYh7hAT2rARoznzmtec/gyQwc/o5dbb/uKUFHGRoC5gdcsKTcy4gEsha/nN7fjpPPT/l1PNTXlQD4MY8NOhlk44WfySAKIL/IEuOdcLC5Tb12WUHaPGGk/jhBPj3bPMVL74OEuBDAZxCe9R/4rppBziqZocCFgmgh6BFAulIrl8AAZ9yAj7lBHzKSyeATtB5749qv9n7J8fa1IXLLli41HJhHd5dFCEkICRAWsC3B7oOPxzs+nv0DZgZsEjAGg7MDnTC3EArPDvfBqmRduAkUIQICPiUE/ApL0oAliMQdwiKtgP2/jrO9Uc7GI7/1dE2VR1zQHqs6atzg80O/HJUd/EVhQSEBNYgAVKjv9l/9L0PhrpmTBI4bg4HOAkcZvODHTA/1GYjgY4sESAZWIRAwKecgE95SQSAZBBtY0gCCH493qbqow7QRx3fTF50HMVXxaXNa3hlcauQgJCAXQLRbqka//7W4JHvQU1gZuA4zL72nDp3+gSbO30U5vqRBDrZkzPtsHihE9IRJID81MbdhAn8mJs9OfXo7dwNGEmACIHyrCuwi6kxTOga7GIc/NwduOnNZLTlONaRCMtef3EsJCAksEYJEAn8/WuHjjzqf+4GGgbnXjuhz712TEcSwCnCuYEOiwTaIT1yMDdFOkAbySWB1RGAi+lRTKgBuPR03GWooy7Q4i3xJ9HGVnw9Af41fmRxu5DAchIggKFhcOb0ic/NnT4OmGZPH1dn+o8Y6Cg0O9jG5s+62MKFTkiOHOIpPXKYk0GWAHDVIGoAub09HwLwFYL289leX4+4DD3qUk0NwAlavClI9aW60d8iFxIQEtgACdiNa3Onj35o5vSRb+OQ4NHQMZgd6tJmBjqM2TPtDNcMzJ3rZE/PdzIkADV6iKv89iEAHqsjTk4GmOsjLjPxnp56fCQAh6HGHKqNML6ujzh+jl7PXic6J3IhASGBjZNABYHura+0tEwPHVceDB5bmB46BDwNHtSnhw5qs0Od7MnZTvbsXCdLXuwAdbiNqcMuhpqAOtzKU/oikoCDpS+2MO1iK+gjrUyLOJk24jT0qEPTIw5dj+EeDi2gR1wz3/nt994ekA7gq1mefsLHf+O+syhZSKC4BOxq9ztf6Tz+9ulO39uDh95+dPY4zF94F8yfOwazAx3swauN6vRXGrRnZ5y6eqHD0IY7DW2kk+mRDqZH2gwj1mHokTadjXRo2kirhgSAQUV4IJB4C6RjTW9p0ZbuZ+cOHKTa2J9N50QuJCAksPkSqLCDEcOKvfPa0V998OqhL8+8dnjmyZkjkBo5BurIcVg83wXPMJ7A+UOQvHAYUsOHuG1AjZqOPejcg9oBgj8Zc7ydjjm+tBhv/sX756VMOC+c4gNJEr3+5n9n8UQhgWUlkEMEeOW3X+lyzpzu+tnZ/sP/bba/40uz/Z1jcwMHvzU/eOjx/NDB+fmhQ3OPXzs4M3e66+tPzxwaTl44+EeLF50fT0Zafmr6tETLePlDLZIRwF/2E4gfhQS2XgJEBAXB+u1XpP18Hwbci+F0a+PUK20NXw+/q65QtdHOYNcuCl0jzgkJCAlsXwlwY6HlQ1CQEOxVR8DjtWRgtP8mjoUEhASEBIQEhASEBIQEhAR2gwT+f20N4behfkz7AAAAAElFTkSuQmCC"
                />
              </defs>
            </svg>

            <h4 style="font-weight: 600; margin-top: 20px">Asset Overdue</h4>
            <p style="font-size: 16px; font-weight: 600">
              You have an asset that is overdue, please submit for
              <br class="break-lines" />
              return or ask for extend
            </p>
          </div>

          <div
            class="d-flex align-items-center"
            style="
              width: 50%;
              border: 1px solid #e7e7e7;
              margin: 0 auto;
              margin: 0 auto;
              padding: 10px 15px;
              border-radius: 8px;
            "
          >
            <div class="inventory-img">
              <img
                [src]="
                  overdueAssetInv?.assetImage === '0' ||
                  !overdueAssetInv?.assetImage
                    ? '../../../../assets/inventories/default-inventory.png'
                    : overdueAssetInv?.assetImage
                "
                alt=""
                width="60px"
                height="60px"
              />
            </div>
            <p
              style="
                font-weight: 600;
                font-weight: 16px;
                margin-left: 10px;
                text-decoration: underline;
              "
            >
              {{ overdueAssetInv?.assetName }}
            </p>
          </div>
          <button
            class="close accept"
            data-dismiss="modal"
            aria-label="Close"
            style="
              border-radius: 6px !important;
              height: 48px !important;
              margin: 20px;
              float: none;
              font-size: 14px;
              opacity: 1;
            "
            (click)="onOverdueSubmit(overdueAssetInv)"
          >
            Submit For Return
          </button>
        </div>
      </div>
    </div>
  </div>
  }
  <!-- Manual Modal -->
  <div
    class="modal fade"
    id="manualModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="manualTitle"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered charging-reminder-width"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header charging-head">
          <h5 class="modal-title">Add Inventory Item</h5>
          <button
            type="button"
            class="close inven-cls"
            data-dismiss="modal"
            aria-label="Close"
          >
            <svg
              class="cross-svg"
              width="14"
              height="12"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5518 1.64453L1.85612 12.3402"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
              <path
                d="M12.5518 12.3401L1.85612 1.64445"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
        <div
          class="modal-body all-req-content d-flex justify-content-center"
          style="padding: 8rem 2rem; gap: 10px"
        >
          <button
            type="button"
            class="manual-btn"
            (click)="openManualServiceReqModal()"
          >
            Service Request
          </button>
          <button
            type="button"
            class="manual-btn"
            (click)="openManualInventoryReqModal()"
          >
            Inventory Request
          </button>
          <button
            type="button"
            class="manual-btn"
            (click)="gotoReturnRequest()"
          >
            Return Request
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Admin Counts -->
  @if(showUserDashboard){
  <div class="assets-overview-card">
    @if(!LoadingShimmer) {
    <div class="assets-content">
      <app-animated-svg></app-animated-svg>
      <div class="d-flex justify-content-between align-items-center">
        <div class="assets-content-left">
          <h2>Total Assets</h2>
          <div class="counts">
            <p class="assets-content-count">{{ this.totalAssets }}</p>
          </div>
          <p
            class="assets-content-count mb-0"
            style="font-size: 16px !important"
          >
            Quantity : {{ this.totalQuantity }}
          </p>
        </div>
        <div class="assets-content-right">
          <img src="/assets/inventories/assigned-assets.png" alt="open leads" />
        </div>
      </div>
    </div>
    <div class="assets-content">
      <app-animated-svg></app-animated-svg>
      <div class="d-flex justify-content-between align-items-center">
        <div class="assets-content-left">
          <h2>Rental Assets</h2>
           <div class="counts">
          <p class="assets-content-count">{{ this.rentalAssets }}</p>
          </div>
         <p
            class="assets-content-count mb-0"
            style="font-size: 16px !important"
          >
            Quantity : {{ this.rentalQuantity  }}
          </p>
          </div>
        <div class="assets-content-right">
          <img src="/assets/inventories/overdue-assets.png" alt="open leads" />
        </div>
      </div>
    </div>
    <div class="assets-content">
      <app-animated-svg></app-animated-svg>
      <div class="d-flex justify-content-between align-items-center">
        <div class="assets-content-left">
          <h2>Available Assets</h2>
           <div class="counts">
          <p class="assets-content-count">{{ this.availableAsset }}</p>
        </div>
        <p
            class="assets-content-count mb-0"
            style="font-size: 16px !important"
          >
            Quantity : {{ this.availableQuantity  }}
          </p>
          </div>
        <div class="assets-content-right">
          <img src="/assets/inventories/approved-asset.png" alt="open leads" />
        </div>
      </div>
    </div>
    <div class="assets-content">
      <app-animated-svg></app-animated-svg>
      <div class="d-flex justify-content-between align-items-center">
        <div class="assets-content-left">
          <h2>Went for Demos</h2>
           <div class="counts">
          <p class="assets-content-count">{{ this.wentForDemo }}</p>
        </div>
         <p
            class="assets-content-count mb-0"
            style="font-size: 16px !important"
          >
            Quantity : {{ this.demoQuantity  }}
          </p>
          </div>
        <div class="assets-content-right">
          <img src="/assets/inventories/pending-asset.png" alt="open leads" />
        </div>
      </div>
    </div>
    } @else {
    <!-- Shimmer Loading Cards -->
    <div class="shimmer-count-container d-flex justify-content-between">
      <div class="shimmer-card-count">
        <div
          class="shimmer-content d-flex justify-content-between align-items-center"
        >
          <div>
            <div class="shimmer-title"></div>
            <div class="shimmer-count"></div>
          </div>
          <div class="shimmer-image"></div>
        </div>
      </div>

      <div class="shimmer-card-count">
        <div
          class="shimmer-content d-flex justify-content-between align-items-center"
        >
          <div>
            <div class="shimmer-title"></div>
            <div class="shimmer-count"></div>
          </div>
          <div class="shimmer-image"></div>
        </div>
      </div>

      <div class="shimmer-card-count">
        <div
          class="shimmer-content d-flex justify-content-between align-items-center"
        >
          <div>
            <div class="shimmer-title"></div>
            <div class="shimmer-count"></div>
          </div>
          <div class="shimmer-image"></div>
        </div>
      </div>

      <div class="shimmer-card-count">
        <div
          class="shimmer-content d-flex justify-content-between align-items-center"
        >
          <div>
            <div class="shimmer-title"></div>
            <div class="shimmer-count"></div>
          </div>
          <div class="shimmer-image"></div>
        </div>
      </div>
    </div>
    }
  </div>
  } @if(!showUserDashboard) {
  <div class="assets-overview-card">
    @if(!LoadingShimmer) {
    <!-- Real Cards -->
    <div class="assets-content">
      <app-animated-svg></app-animated-svg>
      <div class="d-flex justify-content-between align-items-center">
        <div class="assets-content-left">
          <h2>Assigned Assets</h2>
          <p class="assets-content-count">{{ totalAssigned }}</p>
        </div>
        <div class="assets-content-right">
          <img
            src="/assets/inventories/assigned-assets.png"
            alt="assigned assets"
          />
        </div>
      </div>
    </div>

    <div class="assets-content">
      <app-animated-svg></app-animated-svg>
      <div class="d-flex justify-content-between align-items-center">
        <div class="assets-content-left">
          <h2>Overdue Assets</h2>
          <p class="assets-content-count">{{ this.totalOverdueAssets }}</p>
        </div>
        <div class="assets-content-right">
          <img src="/assets/inventories/overdue-assets.png" alt="open leads" />
        </div>
      </div>
    </div>
    <div class="assets-content">
      <app-animated-svg></app-animated-svg>
      <div class="d-flex justify-content-between align-items-center">
        <div class="assets-content-left">
          <h2>Approved Request</h2>
          <p class="assets-content-count">{{ this.approveCount }}</p>
        </div>
        <div class="assets-content-right">
          <img src="/assets/inventories/approved-asset.png" alt="open leads" />
        </div>
      </div>
    </div>
    <div class="assets-content">
      <app-animated-svg></app-animated-svg>
      <div class="d-flex justify-content-between align-items-center">
        <div class="assets-content-left">
          <h2>Pending Requests</h2>
          <p class="assets-content-count">{{ this.pendingCount }}</p>
        </div>
        <div class="assets-content-right">
          <img src="/assets/inventories/pending-asset.png" alt="open leads" />
        </div>
      </div>
    </div>
    } @else {
    <!-- Shimmer Loading Cards -->
    <div class="shimmer-count-container d-flex justify-content-between">
      <div class="shimmer-card-count">
        <div
          class="shimmer-content d-flex justify-content-between align-items-center"
        >
          <div>
            <div class="shimmer-title"></div>
            <div class="shimmer-count"></div>
          </div>
          <div class="shimmer-image"></div>
        </div>
      </div>

      <div class="shimmer-card-count">
        <div
          class="shimmer-content d-flex justify-content-between align-items-center"
        >
          <div>
            <div class="shimmer-title"></div>
            <div class="shimmer-count"></div>
          </div>
          <div class="shimmer-image"></div>
        </div>
      </div>

      <div class="shimmer-card-count">
        <div
          class="shimmer-content d-flex justify-content-between align-items-center"
        >
          <div>
            <div class="shimmer-title"></div>
            <div class="shimmer-count"></div>
          </div>
          <div class="shimmer-image"></div>
        </div>
      </div>

      <div class="shimmer-card-count">
        <div
          class="shimmer-content d-flex justify-content-between align-items-center"
        >
          <div>
            <div class="shimmer-title"></div>
            <div class="shimmer-count"></div>
          </div>
          <div class="shimmer-image"></div>
        </div>
      </div>
    </div>
    }
  </div>
  }

  <!--Inventory Checkout Requests Table -->
  <div>
    @if(showUserDashboard){
    <div class="checkout-request">
      <div class="checkout-head-cont d-flex justify-content-between">
        <div class="checkout-head d-flex align-items-center">
          <h2>Inventory Requests</h2>
          <p>
            <span>{{ this.totalInventoryRequest }}</span>
          </p>
        </div>
        @if (inventoriesReq.length > 5) {
        <div class="view-parent">
          <p
            class="view-all"
            (click)="navigateToInventoryReq()"
            style="cursor: pointer"
          >
            <!-- {{ viewAll ? 'Show Less' : 'Show More' }} -->
            View All
          </p>
        </div>
        }
      </div>

      <div class="checked-out-inv">
        @if(!isShimmerLoading){
        <table
          class="fixed-header-table"
          style="overflow-x: auto; height: 540px"
        >
          <thead>
            <tr
              style="
                border-top: 1px solid #e7e7e7;
                border-bottom: 1px solid #e7e7e7;
              "
            >
              <th scope="col" style="width: 25%">ASSET NAME</th>
              <th scope="col" style="width: 15%">REQUESTED BY</th>
              <th scope="col" style="width: 15%">REQUESTED TO</th>
              <th scope="col" style="width: 15%">REQUESTED ON</th>
              <th scope="col" style="width: 15%">FOR PROJECT</th>
              <th scope="col" style="width: 15%">URGENCY</th>
              <th scope="col" style="width: 15%">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            @for (inventory of inventoriesReq | slice:0:(viewAll ?
            inventoriesReq.length : 5); track $index) {
            <tr>
              <td>
                <div class="d-flex align-items-center" style="width: 80%">
                  <p style="margin-bottom: 0; font-size: 13px">
                    {{ $index + 1 }}
                  </p>
                  <div class="inventory-img">
                    <img
                      [src]="
                        inventory.assetImage
                          ? inventory.assetImage
                          : '../../../assets/inventories/default-inventory.png'
                      "
                      alt=""
                      width="60px"
                      height="60px"
                    />
                  </div>
                  <p>{{ inventory.assetName }}</p>
                </div>
              </td>
              <td>
                <p>{{ inventory.requestedBy }}</p>
              </td>
              <td>
                <p>{{ inventory.requestedTo }}</p>
              </td>
              <td>
                <p>{{ inventory.requestedOn }}</p>
              </td>
              <td class="project-name">
                <p>{{ inventory.project }}</p>
              </td>
              <td>
                <p
                  [ngClass]="{
                    'text-red': inventory.urgency === 'High',
                    'text-orange': inventory.urgency === 'Medium',
                    'text-blue': inventory.urgency === 'Low'
                  }"
                >
                  {{ inventory.urgency }}
                </p>
              </td>
              <td>
                <div
                  class="d-flex align-items-center justify-content-between"
                  style="margin-left: 20px"
                >
                  <button
                    mat-stroked-button
                    (click)="acceptInvRequest(inventory.requestId)"
                    class="snack-btn"
                  >
                    <svg
                      width="41"
                      height="42"
                      viewBox="0 0 41 42"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style="margin-right: 10px; cursor: pointer"
                    >
                      <rect
                        y="0.555725"
                        width="40.9"
                        height="40.9"
                        rx="20.45"
                        fill="#24BA61"
                      />
                      <path
                        d="M13.6743 21.2918L18.3529 25.9703L27.2255 17.0977"
                        stroke="white"
                        stroke-width="2.5"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>

                  <button
                    class="snack-btn"
                    mat-stroked-button
                    (click)="declineInvRequest(inventory.requestId)"
                  >
                    <svg
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style="cursor: pointer"
                    >
                      <rect
                        x="0.359619"
                        y="0.555725"
                        width="40.9"
                        height="40.9"
                        rx="20.45"
                        fill="#F74A4A"
                      />
                      <path
                        opacity="0.7"
                        d="M16.3733 25.9703L25.2459 17.0977"
                        stroke="white"
                        stroke-width="2.5"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16.3733 17.0977L25.2459 25.9703"
                        stroke="white"
                        stroke-width="2.5"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
            }
          </tbody>
          @if(inventoriesReq.length === 0){
          <app-no-data></app-no-data>
          }
        </table>
        }
      </div>
      @if(isShimmerLoading) { @for (inventory of shimmerLoadingValue; track
      inventory; let i = $index) {
      <span class="d-flex">
        <div class="shimmer-card">
          <div class="shimmerBG media"></div>
          <div class="p-32">
            <div class="shimmerBG title-line"></div>
            <div class="shimmerBG title-line end"></div>

            <div class="shimmerBG content-line m-t-24"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line end"></div>
          </div>
        </div>
      </span>
      } }
    </div>

    <!-- New Inventory Requests -->
    <div class="checkout-request new-inv-req">
      <div class="checkout-head-cont d-flex justify-content-between">
        <div class="checkout-head d-flex align-items-center">
          <h2>New Inventory Requests</h2>
          <p>
            <span>{{ this.totalNewInventory }} </span>
          </p>
        </div>
        @if (newInventories.length > 5) {
        <div class="view-parent">
          <p
            class="view-all"
            (click)="navigateToNewInventoryReq()"
            style="cursor: pointer"
          >
            <!-- {{ viewAll ? 'Show Less' : 'Show More' }} -->
            View All
          </p>
        </div>
        }
      </div>

      <div
        class="checked-out-inv"
        infiniteScroll
        #infiniteScroller
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        (scrolled)="onNewInvScroll()"
        [scrollWindow]="false"
        style="
          max-height: calc(100vh - 312px);
          overflow-y: scroll;
          min-height: 512px;
        "
      >
        <table class="fixed-header-table" style="overflow-x: auto">
          <thead>
            <tr
              style="
                border-top: 1px solid #e7e7e7;
                border-bottom: 1px solid #e7e7e7;
              "
            >
              <th scope="col" style="width: 25%">ASSET TYPE</th>
              <th scope="col" style="width: 15%">REQUESTED BY</th>
              <th scope="col" style="width: 15%">REQUESTED TO</th>
              <th scope="col" style="width: 15%">REQUESTED ON</th>
              <th scope="col" style="width: 15%">START DATE</th>
              <th scope="col" style="width: 15%">URGENCY</th>
              <th scope="col" style="width: 15%">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            @for (newInventory of newInventories | slice:0: (viewAll ?
            newInventories.length : 5); track $index) {
            <tr>
              <td>
                <p>{{ newInventory.assetCategory }}</p>
              </td>
              <td>
                <p>{{ newInventory.requestedBy }}</p>
              </td>
              <td>
                <p>{{ newInventory.requestedTo }}</p>
              </td>
              <td>
                <p>{{ newInventory.requestedOn }}</p>
              </td>
              <td>
                <p
                  [ngClass]="{
                    'text-forward': newInventory.needBy === 'Today'
                  }"
                >
                  {{ newInventory.needBy }}
                </p>
              </td>
              <td>
                <p
                  [ngClass]="{
                    'text-red': newInventory.urgency === 'High',
                    'text-orange': newInventory.urgency === 'Medium',
                    'text-blue': newInventory.urgency === 'Low'
                  }"
                >
                  {{ newInventory.urgency }}
                </p>
              </td>
              <td>
                <div
                  class="d-flex align-items-center justify-content-between"
                  style="margin-left: 20px; cursor: pointer"
                >
                  <button
                    class="snack-btn"
                    [ngClass]="{
                      'forwarded-btn': newInventory.isForwarded,
                      'disabled-div': newInventory.isForwarded
                    }"
                    mat-stroked-button
                    (click)="acceptNewInvRequest(newInventory.requestId)"
                  >
                    <svg
                      width="41"
                      height="42"
                      viewBox="0 0 41 42"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        y="0.555725"
                        width="40.9"
                        height="40.9"
                        rx="20.45"
                        fill="#24BA61"
                      />
                      <path
                        d="M13.6743 21.2918L18.3529 25.9703L27.2255 17.0977"
                        stroke="white"
                        stroke-width="2.5"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>

                  <div
                    data-target="#forwardNewRequestModal"
                    data-toggle="modal"
                    [ngClass]="{
                      'forwarded-btn': newInventory.isForwarded,
                      'disabled-div': newInventory.isForwarded
                    }"
                    (click)="
                      selectedInventory = newInventory;
                      newInvReqId = newInventory.requestId;
                      openForward(newInventory.requestId)
                    "
                  >
                    <svg
                      width="42"
                      height="41"
                      viewBox="0 0 42 41"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style="margin-left: 10px"
                    >
                      <rect
                        x="0.140625"
                        y="-0.00708008"
                        width="40.9"
                        height="40.9"
                        rx="20.45"
                        fill="#FDCC27"
                      />
                      <path
                        opacity="0.8"
                        d="M11.8975 26.9669C12.0104 26.2667 12.2137 25.6027 12.4621 24.9476C13.1578 23.1271 14.1245 21.4783 15.5611 20.1321C16.9886 18.795 18.6826 18.009 20.625 17.765C21 17.7198 21.3749 17.6792 21.7499 17.6837C21.9215 17.6882 21.9622 17.6295 21.9622 17.4669C21.9532 16.4143 21.9577 15.3572 21.9577 14.3047C21.9577 14.2415 21.9577 14.1782 21.9577 14.0653C22.2829 14.3589 22.5766 14.6164 22.8657 14.8784C24.8849 16.6944 26.9042 18.5149 28.9235 20.3309C29.19 20.5703 29.19 20.5703 28.9099 20.8052C26.6693 22.689 24.4287 24.5727 22.1835 26.4565C22.1203 26.5061 22.0571 26.5558 21.9532 26.6326C21.9532 26.5152 21.9532 26.4384 21.9532 26.3571C21.9532 25.1464 21.9486 23.9312 21.9577 22.7206C21.9577 22.5354 21.926 22.4631 21.7182 22.4676C20.2862 22.4902 18.8587 22.5218 17.4493 22.8064C15.2177 23.2536 13.5102 24.4598 12.2814 26.3616C12.1504 26.5604 12.0239 26.7636 11.8975 26.9669Z"
                        fill="#030303"
                      />
                    </svg>
                  </div>

                  <button
                    class="snack-btn"
                    mat-stroked-button
                    [ngClass]="{
                      'forwarded-btn': newInventory.isForwarded,
                      'disabled-div': newInventory.isForwarded
                    }"
                    (click)="declineNewInvRequest(newInventory.requestId)"
                  >
                    <svg
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style="margin-left: 10px; cursor: pointer"
                    >
                      <rect
                        x="0.359619"
                        y="0.555725"
                        width="40.9"
                        height="40.9"
                        rx="20.45"
                        fill="#F74A4A"
                      />
                      <path
                        opacity="0.7"
                        d="M16.3733 25.9703L25.2459 17.0977"
                        stroke="white"
                        stroke-width="2.5"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16.3733 17.0977L25.2459 25.9703"
                        stroke="white"
                        stroke-width="2.5"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
        @if(newInventories.length === 0){
        <app-no-data></app-no-data>
        }
      </div>
    </div>

    <!-- New Service Requests -->
    <div class="checkout-request">
      <div class="checkout-head-cont d-flex justify-content-between">
        <div class="checkout-head d-flex align-items-center">
          <h2>New Service Requests</h2>
          <p>
            <span>{{ this.totalService }}</span>
          </p>
        </div>
        @if (serviceRequest.length > 5) {
        <div class="view-parent">
          <p
            class="view-all"
            (click)="navigateToServiceRequest()"
            style="cursor: pointer"
          >
            <!-- {{ viewAll ? 'Show Less' : 'Show More' }} -->
            View All
          </p>
        </div>
        }
      </div>

      <!--New Service Requests Table -->
      <div class="checked-out-inv" style="height: 512px">
        <table style="overflow-x: auto">
          <thead>
            <tr
              style="
                border-top: 1px solid #e7e7e7;
                border-bottom: 1px solid #e7e7e7;
              "
            >
              <th scope="col" style="width: 25%">ASSET TYPE</th>
              <th scope="col" style="width: 15%">SERVICE TYPE</th>
              <th scope="col" style="width: 15%">DAMAGE</th>
              <th scope="col" style="width: 15%">REQUESTED BY</th>
              <th scope="col" style="width: 15%">REQUESTED ON</th>
              <th scope="col" style="width: 15%">URGENCY</th>
              <th scope="col" style="width: 15%">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            @for (service of serviceRequest | slice:0:(viewAll ?
            serviceRequest.length : 5); track $index) {
            <tr>
              <td>
                <div class="d-flex align-items-center" style="width: 80%">
                  <p style="margin-bottom: 0; font-size: 13px">
                    {{ $index + 1 }}
                  </p>
                  <div class="inventory-img">
                    <img
                      [src]="
                        service.assetImage && service.assetImage !== '0'
                          ? service.assetImage
                          : '../../../assets/inventories/default-inventory.png'
                      "
                      alt=""
                      width="60px;"
                      height="60px"
                    />
                  </div>
                  <p>{{ service.assetName }}</p>
                </div>
              </td>
              <td>
                <p>{{ service.serviceType }}</p>
              </td>
              <td>
                <p>{{ service.damage }}</p>
              </td>
              <td>
                <p>{{ service.requestedBy }}</p>
              </td>
              <td>
                <p>{{ service.requestedOn }}</p>
              </td>
              <td>
                <p
                  [ngClass]="{
                    'text-red': service.urgency === 'High',
                    'text-orange': service.urgency === 'Medium',
                    'text-blue': service.urgency === 'Low'
                  }"
                >
                  {{ service.urgency }}
                </p>
              </td>
              <td>
                <div
                  class="d-flex align-items-center justify-content-between"
                  style="margin-left: 20px; cursor: pointer"
                >
                  <div>
                    <button
                      class="snack-btn"
                      mat-stroked-button
                      [ngClass]="{
                        'forwarded-btn': service.isForwarded,
                        'disabled-div': service.isForwarded
                      }"
                      (click)="acceptNewServiceRequest(service.requestId)"
                    >
                      <svg
                        width="41"
                        height="42"
                        viewBox="0 0 41 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          y="0.555725"
                          width="40.9"
                          height="40.9"
                          rx="20.45"
                          fill="#24BA61"
                        />
                        <path
                          d="M13.6743 21.2918L18.3529 25.9703L27.2255 17.0977"
                          stroke="white"
                          stroke-width="2.5"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                  <div
                    data-toggle="modal"
                    data-target="#forwardServiceRequestModal"
                    [ngClass]="{
                      'forwarded-btn': service.isForwarded,
                      'disabled-div': service.isForwarded
                    }"
                    (click)="
                      selectedSerInventory = service;
                      serviceReqId = service.requestId;
                      openForwardService(service.requestId)
                    "
                  >
                    <svg
                      width="42"
                      height="41"
                      viewBox="0 0 42 41"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style="margin-left: 10px"
                    >
                      <rect
                        x="0.140625"
                        y="-0.00708008"
                        width="40.9"
                        height="40.9"
                        rx="20.45"
                        fill="#FDCC27"
                      />
                      <path
                        opacity="0.8"
                        d="M11.8975 26.9669C12.0104 26.2667 12.2137 25.6027 12.4621 24.9476C13.1578 23.1271 14.1245 21.4783 15.5611 20.1321C16.9886 18.795 18.6826 18.009 20.625 17.765C21 17.7198 21.3749 17.6792 21.7499 17.6837C21.9215 17.6882 21.9622 17.6295 21.9622 17.4669C21.9532 16.4143 21.9577 15.3572 21.9577 14.3047C21.9577 14.2415 21.9577 14.1782 21.9577 14.0653C22.2829 14.3589 22.5766 14.6164 22.8657 14.8784C24.8849 16.6944 26.9042 18.5149 28.9235 20.3309C29.19 20.5703 29.19 20.5703 28.9099 20.8052C26.6693 22.689 24.4287 24.5727 22.1835 26.4565C22.1203 26.5061 22.0571 26.5558 21.9532 26.6326C21.9532 26.5152 21.9532 26.4384 21.9532 26.3571C21.9532 25.1464 21.9486 23.9312 21.9577 22.7206C21.9577 22.5354 21.926 22.4631 21.7182 22.4676C20.2862 22.4902 18.8587 22.5218 17.4493 22.8064C15.2177 23.2536 13.5102 24.4598 12.2814 26.3616C12.1504 26.5604 12.0239 26.7636 11.8975 26.9669Z"
                        fill="#030303"
                        (click)="selectedInventory = service"
                      />
                    </svg>
                  </div>
                  <div>
                    <button
                      class="snack-btn"
                      mat-stroked-button
                      [ngClass]="{
                        'forwarded-btn': service.isForwarded,
                        'disabled-div': service.isForwarded
                      }"
                      (click)="declineServiceRequest(service.requestId)"
                    >
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style="margin-left: 10px; cursor: pointer"
                      >
                        <rect
                          x="0.359619"
                          y="0.555725"
                          width="40.9"
                          height="40.9"
                          rx="20.45"
                          fill="#F74A4A"
                        />
                        <path
                          opacity="0.7"
                          d="M16.3733 25.9703L25.2459 17.0977"
                          stroke="white"
                          stroke-width="2.5"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16.3733 17.0977L25.2459 25.9703"
                          stroke="white"
                          stroke-width="2.5"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
        @if(serviceRequest.length === 0){
        <app-no-data></app-no-data>
        }
      </div>
    </div>

    <!-- Inventory Return Requests -->
    <div class="checkout-request">
      <div class="checkout-head-cont d-flex justify-content-between">
        <div class="checkout-head d-flex align-items-center">
          <h2>Inventory Return Requests</h2>
          <p>
            <span>{{ this.totalReturn }}</span>
          </p>
        </div>
        @if (returnInv.length > 5) {
        <div class="view-parent">
          <p
            class="view-all"
            (click)="navigateToReturnReq()"
            style="cursor: pointer"
          >
            <!-- {{ viewAll ? 'Show Less' : 'Show More' }} -->
            View All
          </p>
        </div>
        }
      </div>

      <!--Inventory Return Requests Table -->
      <div
        class="checked-out-inv"
        infiniteScroll
        #infiniteScroller
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        (scrolled)="onInventoryReturnScroll()"
        [scrollWindow]="false"
        style="
          max-height: calc(100vh - 312px);
          overflow-y: auto;
          min-height: 512px;
        "
      >
        <table style="overflow-x: auto; height: 512px">
          <thead>
            <tr
              style="
                border-top: 1px solid #e7e7e7;
                border-bottom: 1px solid #e7e7e7;
              "
            >
              <th scope="col" style="width: 25%">ASSET NAME</th>
              <th scope="col" style="width: 30%">RETURN BY</th>
              <th scope="col" style="width: 20%">RETURN DATE</th>
              <th scope="col" style="width: 20%">TAKEN ON</th>
              <th scope="col" style="width: 20%">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            @for (return of returnInv | slice:0:(viewAll ? returnInv.length :
            5); track $index;) {
            <tr>
              <td>
                <div class="d-flex align-items-center" style="width: 80%">
                  <p style="margin-bottom: 0; font-size: 13px">
                    {{ $index + 1 }}
                  </p>
                  <div class="inventory-img">
                    <img
                      [src]="
                        return.assetImage && return.assetImage !== '0'
                          ? return.assetImage
                          : '../../../../assets/inventories/default-inventory.png '
                      "
                      alt=""
                      width="60px"
                      height="60px"
                    />
                  </div>
                  <p>{{ return.assetName }}</p>
                </div>
              </td>
              <td>
                <p>{{ return.returnBy }}</p>
              </td>
              <td>
                <p>{{ return.returnDate }}</p>
              </td>
              <td>
                <p>{{ return.takenOn }}</p>
              </td>
              <td>
                <button
                  class="take-action"
                  style="margin-left: 10px"
                  data-toggle="modal"
                  data-target="#inventoryReturnReqModal"
                  (click)="
                    !isProcessingAction && openReturnPreviewSlider($index)
                  "
                  [disabled]="isProcessingAction"
                >
                  Take Action
                </button>
              </td>
            </tr>
            }
          </tbody>
          @if(returnInv.length === 0){
          <app-no-data></app-no-data>
          }
        </table>
      </div>
    </div>

    <!-- APPROVED REQUESTS -->
    <div class="checkout-request">
      <div class="checkout-head-cont d-flex justify-content-between">
        <div class="checkout-head d-flex align-items-center">
          <h2>Approved Requests</h2>
          @if(showNewInventoryRequestTable){
          <p>
            <span>{{ this.totalApprNewInventory }}</span>
          </p>
          } @if(showInventoryRequestTable){
          <p>
            <span>{{ this.totalInventoryApprRequest }}</span>
          </p>
          } @if(showService){
          <p>
            <span>{{ this.totalApprService }}</span>
          </p>

          } @if(showReturn){
          <p>
            <span>{{ this.totalApprReturn }}</span>
          </p>
          }
        </div>
        <div
          class="approve-filter d-flex align-items-center justify-content-center"
        >
          <div class="dropdown" style="margin-bottom: 10px">
            <mat-form-field
              style="width: 185px !important; height: 45px !important"
            >
              <mat-select placeholder="New Inventory Request">
                @for (approvedInv of approvedNewInventory; track $index) {
                <mat-option
                  [value]="approvedInv.value"
                  (click)="getApprovedNewInventory()"
                >
                  {{ approvedInv.viewValue }}
                </mat-option>
                } @for (approvedInv of approvedInventory; track $index) {
                <mat-option
                  [value]="approvedInv.value"
                  (click)="getApprovedInventoryRequest()"
                >
                  {{ approvedInv.viewValue }}
                </mat-option>
                } @for (approvedInv of approvedServiceRequest; track $index) {
                <mat-option
                  [value]="approvedInv.value"
                  (click)="getApprovedServiceRequestData()"
                >
                  {{ approvedInv.viewValue }}
                </mat-option>
                } @for (approvedInv of approvedReturn; track $index) {
                <mat-option
                  [value]="approvedInv.value"
                  (click)="getApprovedReturnRequest()"
                >
                  {{ approvedInv.viewValue }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if(showNewInventoryRequestTable){ @if (newApprInventories.length > 5)
          {
          <div class="view-parent">
            <p
              class="view-all"
              (click)="navigateToHRApproved()"
              style="cursor: pointer; margin-left: 20px"
            >
              <!-- {{ viewAll ? 'Show Less' : 'Show More' }} -->
              View All
            </p>
          </div>
          } } @if(showInventoryRequestTable){ @if (inventoriesApprReq.length >
          5) {
          <div class="view-parent">
            <p
              class="view-all"
              (click)="navigateToHRApproved()"
              style="cursor: pointer; margin-left: 20px"
            >
              <!-- {{ viewAll ? 'Show Less' : 'Show More' }} -->
              View All
            </p>
          </div>
          } } @if(showService){ @if (serviceApprRequest.length > 5) {
          <div class="view-parent">
            <p
              class="view-all"
              (click)="navigateToHRApproved()"
              style="cursor: pointer; margin-left: 20px"
            >
              <!-- {{ viewAll ? 'Show Less' : 'Show More' }} -->
              View All
            </p>
          </div>
          } } @if(showReturn){ @if (returnApprInv.length > 5) {
          <div class="view-parent">
            <p
              class="view-all"
              (click)="navigateToHRApproved()"
              style="cursor: pointer; margin-left: 20px"
            >
              <!-- {{ viewAll ? 'Show Less' : 'Show More' }} -->
              View All
            </p>
          </div>
          } }
        </div>
      </div>

      <!-- All Approved New Inventory Request -->
      @if (showNewInventoryRequestTable) {
      <div class="checked-out-inv" style="padding-right: 15px">
        @if(!isShimmerLoading){
        <table style="overflow-x: auto; max-height: 528px; height: 528px">
          <thead>
            <tr style="border-top: 1px solid #e7e7e7">
              <th scope="col" style="width: 15%">ASSET TYPE</th>
              <th scope="col" style="width: 15%">REQUESTED BY</th>
              <!-- <th scope="col">APPROVER</th> -->
              <th scope="col" style="width: 15%">STATUS</th>
              <th scope="col" style="width: 15%">LINKS</th>
              <th scope="col" style="width: 15%">REQUESTED ON</th>
              <th scope="col" style="width: 15%">NEED BY</th>
              <th scope="col" style="width: 15%">FOR PROJECT</th>
              <!-- <th scope="col">REQUESTED FOR</th> -->
              <th scope="col" style="width: 15%">URGENCY</th>
            </tr>
          </thead>
          <tbody>
            @for (newInventory of newApprInventories | slice:0:(viewAll ?
            newApprInventories.length : 5); track $index;) {
            <tr
              data-toggle="modal"
              data-target="#requestDetailModal"
              style="
                border-top: 1px solid #e7e7e7;
                border-bottom: 1px solid #e7e7e7;
              "
            >
              <td>
                <div class="d-flex align-items-center">
                  <p style="margin-bottom: 0; font-size: 13px">
                    {{ $index + 1 }}
                  </p>
                  <p>{{ newInventory.assetCategory }}</p>
                </div>
              </td>
              <td>
                <p>{{ newInventory.requestedBy }}</p>
              </td>
              <!-- <td>
                          <p>-</p>
                      </td> -->
              <td>
                <p class="status-point">{{ newInventory.status }}</p>
              </td>
              <td>
                @if(newInventory.links[0] && newInventory.links[0] !== 'null'){
                <p class="link">
                  <a [href]="newInventory.links[0]">{{
                    newInventory.links[0]
                  }}</a>
                </p>
                } @if(newInventory.links[1] && newInventory.links[1] !==
                'null'){
                <p class="link">
                  <a [href]="newInventory.links[1]">{{
                    newInventory.links[1]
                  }}</a>
                </p>
                } @if(newInventory.links[2] && newInventory.links[2] !==
                'null'){
                <p class="link">
                  <a [href]="newInventory.links[2]">{{
                    newInventory.links[2]
                  }}</a>
                </p>
                }
              </td>
              <td>
                <p>{{ newInventory.requestedOn }}</p>
              </td>
              <td>
                <p>
                  {{ newInventory.needBy }}
                </p>
              </td>
              <td class="project-name">
                <p>{{ newInventory.project }}</p>
              </td>
              <!-- <td>
                          <p>-</p>
                      </td> -->
              <td>
                <p
                  [ngClass]="{
                    'text-red': newInventory.urgency === 'High',
                    'text-orange': newInventory.urgency === 'Medium',
                    'text-blue': newInventory.urgency === 'Low'
                  }"
                >
                  {{ newInventory.urgency }}
                </p>
              </td>
            </tr>
            }
          </tbody>
          @if(newApprInventories.length === 0){
          <app-no-data></app-no-data>
          }
        </table>
        }
      </div>
      @if(isShimmerLoading) { @for (newInventory of shimmerLoadingValue; track
      newInventory; let i = $index) {
      <span class="d-flex">
        <div class="shimmer-card">
          <div class="shimmerBG media"></div>
          <div class="p-32">
            <div class="shimmerBG title-line"></div>
            <div class="shimmerBG title-line end"></div>

            <div class="shimmerBG content-line m-t-24"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line end"></div>
          </div>
        </div>
      </span>
      } } } @if(showInventoryRequestTable){
      <div class="checked-out-inv">
        @if(!isShimmerLoading){
        <table style="overflow: auto; max-height: 510px; height: 510px">
          <thead>
            <tr
              style="
                border-top: 1px solid #e7e7e7;
                border-bottom: 1px solid #e7e7e7;
              "
            >
              <th scope="col" style="width: 15%">ASSET NAME</th>
              <th scope="col" style="width: 15%">REQUESTED BY</th>
              <th scope="col" style="width: 15%">STATUS</th>
              <th scope="col" style="width: 15%">REQUESTED ON</th>
              <th scope="col" style="width: 15%">START DATE</th>
              <th scope="col" style="width: 15%">FOR PROJECT</th>
              <th scope="col" style="width: 15%">LOCATIONS</th>
              <th scope="col" style="width: 15%">URGENCY</th>
            </tr>
          </thead>
          <tbody>
            @for (inventoryrequest of inventoriesApprReq | slice:0:(viewAll ?
            inventoriesApprReq.length : 5); track $index;) {
            <tr data-toggle="modal" data-target="#requestDetailModal">
              <td>
                <div class="d-flex align-items-center">
                  <p style="margin-bottom: 0; font-size: 13px">
                    {{ $index + 1 }}
                  </p>
                  <div class="inventory-img">
                    <img
                      [src]="
                        inventoryrequest.assetImage
                          ? inventoryrequest.assetImage
                          : '../../../assets/inventories/computer-system.jpg'
                      "
                      alt=""
                      style="width: 60px; height: 60px"
                    />
                  </div>
                  <p>{{ inventoryrequest.assetName }}</p>
                </div>
              </td>
              <td>
                <p>{{ inventoryrequest.requestedBy }}</p>
              </td>
              <td>
                <p class="status-point">{{ inventoryrequest.status }}</p>
              </td>
              <td>
                <p>{{ inventoryrequest.requestedOn }}</p>
              </td>
              <td>
                <p>{{ inventoryrequest.startDate }}</p>
              </td>
              <td class="project-name">
                <p class="details-text" title="{{ inventoryrequest.project }}">
                  {{ inventoryrequest.project }}
                </p>
              </td>
              <td>
                <p class="details-text" title="{{ inventoryrequest.location }}">
                  {{ inventoryrequest.location }}
                </p>
              </td>
              <td>
                <p
                  [ngClass]="{
                    'text-red': inventoryrequest.urgency === 'High',
                    'text-orange': inventoryrequest.urgency === 'Medium',
                    'text-blue': inventoryrequest.urgency === 'Low'
                  }"
                >
                  {{ inventoryrequest.urgency }}
                </p>
              </td>
            </tr>
            }
          </tbody>
          @if(inventoriesApprReq.length === 0){
          <app-no-data></app-no-data>
          }
        </table>
        }
      </div>
      @if(isShimmerLoading) { @for (inventoryrequest of shimmerLoadingValue;
      track inventoryrequest; let i = $index) {
      <span class="d-flex">
        <div class="shimmer-card">
          <div class="shimmerBG media"></div>
          <div class="p-32">
            <div class="shimmerBG title-line"></div>
            <div class="shimmerBG title-line end"></div>

            <div class="shimmerBG content-line m-t-24"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line"></div>
            <div class="shimmerBG content-line end"></div>
          </div>
        </div>
      </span>
      } } }
      <!-- service Request Table -->
      @if (showService) {
      <div class="checked-out-inv">
        @if(!isShimmerLoading){
        <table style="overflow-x: auto; max-height: 510px; height: 510px">
          <thead>
            <tr
              style="
                border-top: 1px solid #e7e7e7;
                border-bottom: 1px solid #e7e7e7;
              "
            >
              <th scope="col" style="width: 15%">ASSET NAME</th>
              <th scope="col" style="width: 15%">REQUESTED BY</th>
              <th scope="col" style="width: 15%">SERVICE TYPE</th>
              <th scope="col" style="width: 15%">DAMAGE</th>
              <th scope="col" style="width: 15%">OTHER DETAILS</th>
              <th scope="col" style="width: 15%">REQUESTED ON</th>
              <th scope="col" style="width: 15%">NEED BY</th>
              <th scope="col" style="width: 15%">URGENCY</th>
            </tr>
          </thead>
          <tbody>
            @for (serviceReq of serviceApprRequest | slice: 0 :(viewAll ?
            serviceApprRequest.length : 5); track $index; ) {
            <tr data-toggle="modal">
              <td>
                <div class="d-flex align-items-center">
                  <p style="margin-bottom: 0; font-size: 13px">
                    {{ $index + 1 }}
                  </p>
                  <div class="request-img inventory-img">
                    <img
                      [src]="
                        serviceReq.assetImage && serviceReq.assetImage !== '0'
                          ? serviceReq.assetImage
                          : '../../../../assets/inventories/default-inventory.png'
                      "
                      alt=""
                      width="60px"
                      height="60px"
                    />
                  </div>
                  <p>{{ serviceReq.assetName }}</p>
                </div>
              </td>
              <td>
                <p>{{ serviceReq.requestedBy }}</p>
              </td>
              <td>
                <p>{{ serviceReq.serviceType }}</p>
              </td>
              <td>
                <p>{{ serviceReq.damage }}</p>
              </td>
              <td>
                <p
                  class="other-details"
                  style="
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    width: 130px;
                  "
                >
                  {{ serviceReq.details }}
                </p>
              </td>

              <td>
                <p>{{ serviceReq.requestedOn }}</p>
              </td>
              <td>
                <p>{{ serviceReq.needBy }}</p>
              </td>
              <td>
                <p
                  [ngClass]="{
                    'text-red': serviceReq.urgency === 'High',
                    'text-orange': serviceReq.urgency === 'Medium',
                    'text-blue': serviceReq.urgency === 'Low'
                  }"
                >
                  {{ serviceReq.urgency }}
                </p>
              </td>
            </tr>
            }
          </tbody>
          @if(serviceApprRequest.length === 0){
          <app-no-data></app-no-data>
          }
        </table>
        } @if(isShimmerLoading) { @for (serviceReq of shimmerLoadingValue; track
        serviceReq; let i = $index) {
        <span class="d-flex">
          <div class="shimmer-card">
            <div class="shimmerBG media"></div>
            <div class="p-32">
              <div class="shimmerBG title-line"></div>
              <div class="shimmerBG title-line end"></div>

              <div class="shimmerBG content-line m-t-24"></div>
              <div class="shimmerBG content-line"></div>
              <div class="shimmerBG content-line"></div>
              <div class="shimmerBG content-line"></div>
              <div class="shimmerBG content-line end"></div>
            </div>
          </div>
        </span>
        } }
      </div>
      } @if(showReturn){
      <!--Inventory Return Requests Table -->
      <div class="checked-out-inv" style="overflow-x: auto">
        <table style="overflow-x: auto; height: 470px">
          <thead>
            <tr
              style="
                border-top: 1px solid #e7e7e7;
                border-bottom: 1px solid #e7e7e7;
              "
            >
              <th scope="col" style="width: 30%">ASSET NAME</th>
              <th scope="col" style="width: 30%">RETURN BY</th>
              <th scope="col" style="width: 35%">RETURN DATE</th>
              <th scope="col" style="width: 30%">TAKEN ON</th>
              <!-- <th scope="col" style="width: 20%">ACTIONS</th> -->
            </tr>
          </thead>
          <tbody>
            @for (return of returnApprInv | slice:0:(viewAll ?
            newApprInventories.length : 5); track $index;) {
            <tr>
              <td>
                <div class="d-flex align-items-center" style="width: 80%">
                  <p style="margin-bottom: 0; font-size: 13px">
                    {{ $index + 1 }}
                  </p>
                  <div class="inventory-img">
                    <img
                      [src]="
                        return.images[0] && return.images[0] !== '0'
                          ? return.images[0]
                          : '../../../../assets/inventories/default-inventory.png'
                      "
                      alt=""
                      width="60px"
                      height="60px"
                    />
                  </div>
                  <p>{{ return.assetName }}</p>
                </div>
              </td>
              <td>
                <p>{{ return.returnBy }}</p>
              </td>
              <td>
                <p>{{ return.returnDate }}</p>
              </td>
              <td>
                <p>{{ return.takenOn }}</p>
              </td>
            </tr>
            }
          </tbody>
          @if(returnApprInv.length === 0){
          <app-no-data></app-no-data>
          }
        </table>
      </div>
      }
    </div>

    <!-- Extend Request -->
    <div class="checkout-request">
      <div class="checkout-head-cont d-flex justify-content-between">
        <div class="checkout-head d-flex align-items-center">
          <h2>Extend Request</h2>
          <p>
            <span>{{ this.totalExtend }}</span>
          </p>
        </div>
        @if (extendInv.length > 5) {
        <div class="view-parent">
          <p
            class="view-all"
            (click)="viewAll = !viewAll"
            style="cursor: pointer"
          >
            {{ viewAll ? "Show Less" : "Show More" }}
            <!-- View All -->
          </p>
        </div>
        }
      </div>

      <!-- Extend Request Table -->
      <div
        class="checked-out-inv"
        style="height: calc(100vh - 312px); overflow-x: auto; min-height: 512px"
      >
        <table
          class="fixed-header-table"
          style="overflow-x: auto; height: 512px"
        >
          <thead>
            <tr
              style="
                border-top: 1px solid #e7e7e7;
                border-bottom: 1px solid #e7e7e7;
              "
            >
              <th scope="col" style="width: 20%">ASSET NAME</th>
              <th scope="col" style="width: 20%">TAKEN BY</th>
              <th scope="col" style="width: 20%">TAKEN ON</th>
              <th scope="col" style="width: 20%">RETURN DATE</th>
              <th scope="col" style="width: 20%">REQUESTED FOR</th>
              <th scope="col" style="width: 20%">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            @for (extend of extendInv | slice:0:(viewAll ? extendInv.length :
            5); track $index) {
            <tr>
              <td>
                <div class="d-flex align-items-center" style="width: 80%">
                  <p style="margin-bottom: 0; font-size: 13px">
                    {{ $index + 1 }}
                  </p>
                  <div class="inventory-img">
                    <img
                      [src]="
                        extend.assetImage && extend.assetImage !== '0'
                          ? extend.assetImage
                          : '../../../../assets/inventories/default-inventory.png'
                      "
                      alt=""
                      width="60px"
                      height="60px"
                    />
                  </div>
                  <p>{{ extend.assetName }}</p>
                </div>
              </td>
              <td>
                <p>{{ extend.takenBy }}</p>
              </td>
              <td>
                <p>{{ extend.takenOn }}</p>
              </td>
              <td>
                <p>{{ extend.returnDate }}</p>
              </td>
              <td>
                <p>{{ extend.requestedFor }} Days</p>
              </td>

              <td>
                <div class="d-flex align-items-center">
                  <button
                    class="accept"
                    style="margin-right: 15px"
                    (click)="acceptExtendRequest(extend.requestId)"
                  >
                    Accept
                  </button>
                  <button
                    class="decline"
                    (click)="declineExtendRequest(extend.requestId)"
                  >
                    Decline
                  </button>
                </div>
              </td>
            </tr>

            }
          </tbody>
          @if(extendInv.length === 0){
          <app-no-data></app-no-data>
          }
        </table>
      </div>
    </div>

    <!-- Charging Reminder -->
    <!-- <div class="checkout-request">
      <div class="checkout-head-cont d-flex justify-content-between">
        <div class="checkout-head d-flex align-items-center">
          <h2>Charging Reminder</h2>
          <p><span>2</span></p>
        </div>
        <p>Show More</p>
      </div>
      <div class="checked-out-inv" style="overflow-x: auto">
        <table>
          <thead>
            <tr style="
              border-top: 1px solid #e7e7e7;
              border-bottom: 1px solid #e7e7e7;
            ">
              <th scope="col" style="width:30%">ASSET NAME</th>
              <th scope="col" style="width:20%">CHARGE CYCLE</th>
              <th scope="col" style="width:20%">CHARGE BY</th>
              <th scope="col" style="width:20%">OVERDUE FOR</th>
              <th scope="col" style="width:30%">ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="d-flex align-items-center" style="width: 80%">
                  <div class="inventory-img">
                    <img src="../../../../assets/inventories/drone.png" alt="" />
                  </div>
                  <p>DJI Mini 4 Pro Fly More Combo</p>
                </div>
              </td>
              <td>
                <p>Every 7 Days</p>
              </td>
              <td>
                <p>02 July 2024</p>
              </td>
              <td>
                <p>1 Days</p>
              </td>
              <td>
                <button class="take-action">Take Action</button>
              </td>
            </tr>
            <tr>
              <td>
                <div class="d-flex align-items-center" style="width: 80%">
                  <div class="inventory-img">
                    <img src="../../../../assets/inventories/drone.png" alt="" />
                  </div>
                  <p>DJI Mini 4 Pro Fly More Combo</p>
                </div>
              </td>
              <td>
                <p>Every 7 Days</p>
              </td>
              <td>
                <p>02 July 2024</p>
              </td>
              <td>
                <p>1 Days</p>
              </td>
              <td>
                <button class="take-action" data-toggle="modal" data-target="#chargingReminderModal">
                  Take Action
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>  -->
    }
  </div>

  @if(!showUserDashboard){
  <!-- Assigned Assets -->
  <div
    class="checkout-request"
    style="
      max-height: calc(100vh - 155px);
      overflow-y: scroll;
      min-height: 600px;
    "
  >
    <div class="checkout-head-cont d-flex justify-content-between">
      <div class="checkout-head d-flex align-items-center">
        <h2>Assigned Assets</h2>
        <p>
          <span>{{ this.totalAssigned }}</span>
        </p>
      </div>
      @if (inventory.length > 5) {
      <div class="view-parent">
        <p
          class="view-all"
          (click)="redirectToAssigned()"
          style="cursor: pointer"
        >
          View All
        </p>
      </div>
      }
    </div>

    <!-- Assigned Assets Table -->
    <div class="checked-out-inv" style="overflow-x: auto">
      @if(!isShimmerLoading){
      <table class="fixed-header-table" style="overflow-x: auto; height: 520px">
        <thead>
          <tr
            style="
              border-top: 1px solid #e7e7e7;
              border-bottom: 1px solid #e7e7e7;
              margin: 0 20px;
            "
          >
            <th scope="col" style="width: 830px">ASSET NAME</th>
            <th scope="col" style="width: 630px">ASSIGNED ON</th>
            <!-- <th scope="col" style="width:25%">RETURN DATE</th>
            <th scope="col" style="width:25%">REQUESTED FOR</th> 
            <th scope="col" style="width:25%">FOR PROJECT</th> -->
            <th scope="col" style="width: 440px">ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          @for (inventories of inventory | slice:0:(viewAssigned ?
          inventory.length : 5); track $index) {

          <tr>
            <td>
              <div class="d-flex align-items-center" style="width: 80%">
                <p style="margin-bottom: 0; font-size: 13px">
                  {{ $index + 1 }}
                </p>
                <div class="inventory-img">
                  <img
                    [src]="
                      inventories.assetImage && inventories.assetImage !== '0'
                        ? inventories.assetImage
                        : '../../../../assets/inventories/default-inventory.png'
                    "
                    alt=""
                    width="60px"
                    height="60px"
                  />
                </div>
                <p>{{ inventories.assetName }}</p>
              </div>
            </td>
            <td>
              <p>{{ inventories.assignedOn }}</p>
            </td>
            <!-- <td>
              <p>-</p>
            </td> -->
            <!-- <td>
              <p class="text-center">{{inventories.requestedFor ? inventories.requestedFor : '-' }}</p>
            </td>
            <td class="project-name">
              <p>{{inventories.project ? inventories.project : '-'}}</p>
            </td> -->

            <td>
              <div class="d-none align-items-center justify-content-between">
                <button class="send d-none">Send Reminder</button>
                <button class="sent">
                  <svg
                    width="13"
                    height="10"
                    viewBox="0 0 13 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="margin-right: 5px"
                  >
                    <path
                      d="M1.76489 4.95386L5.23359 8.5006L12.0059 1.57594"
                      stroke="#24BA61"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Reminder Sent
                </button>
                <button class="take-action extend-action">Extend</button>
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <!-- <button class="take-action" style="margin-right: 15px;"
                  (click)="openReturn(inventories.assignedInventoryId,$index)" data-target="#assignedExtendModal"
                  data-toggle="modal">Request for Extend</button> -->
                <button
                  class="decline"
                  data-toggle="modal"
                  data-target="#assignedReturnModal"
                  [disabled]="inventories.isReturnRequested"
                  [ngClass]="{
                    'return-requested': inventories.isReturnRequested
                  }"
                  (click)="openReturn(inventories.assignedInventoryId, $index)"
                >
                  {{
                    inventories.isReturnRequested
                      ? "Return Requested"
                      : "Return"
                  }}
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
        @if(inventory.length === 0){
        <app-no-data></app-no-data>
        }
      </table>
      }
    </div>
    @if(isShimmerLoading) { @for (inventoryrequest of shimmerLoadingValue; track
    inventoryrequest; let i = $index) {
    <span class="d-flex">
      <div class="shimmer-card">
        <div class="shimmerBG media"></div>
        <div class="p-32">
          <div class="shimmerBG title-line"></div>
          <div class="shimmerBG title-line end"></div>

          <div class="shimmerBG content-line m-t-24"></div>
          <div class="shimmerBG content-line"></div>
          <div class="shimmerBG content-line"></div>
          <div class="shimmerBG content-line"></div>
          <div class="shimmerBG content-line end"></div>
        </div>
      </div>
    </span>
    } }
  </div>

  <!-- APPROVED REQUESTS -->
  <div class="checkout-request">
    <div class="checkout-head-cont d-flex justify-content-between">
      <div class="checkout-head d-flex align-items-center">
        <h2>Approved Requests</h2>
        <p>
          <span>{{ this.totalApproved }}</span>
        </p>
      </div>
      <div class="apprv-req d-flex align-items-center justify-content-center">
        <div class="dropdown" style="margin-bottom: 10px">
          <mat-form-field
            style="width: 185px !important; height: 45px !important"
          >
            <mat-select placeholder="Inventory Request">
              @for (request of requests; track $index) {
              <mat-option
                [value]="request.value"
                (click)="onApprovedReqSelect(request.value)"
              >
                {{ request.viewValue }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        @if (approveInv.length > 5) {
        <div class="view-parent">
          <p
            class="view-all"
            (click)="navigateToApproved()"
            style="cursor: pointer; margin-left: 10px"
          >
            View All
          </p>
        </div>
        }
      </div>
    </div>

    <!--Inventory Approved Requests Table -->
    @if (!showServiceApproved) {
    <div class="checked-out-inv" style="overflow-x: auto">
      <table class="fixed-header-table" style="overflow-x: auto; height: 520px">
        <thead>
          <tr
            style="
              border-top: 1px solid #e7e7e7;
              border-bottom: 1px solid #e7e7e7;
            "
          >
            @if(!showApprovedReturn){
            <th scope="col" style="width: 20%">ASSET NAME</th>
            } @if(showApprovedReturn){
            <th scope="col" style="width: 580px">ASSET NAME</th>
            } @if(!showApprovedReturn){
            <th scope="col" style="width: 20%">REQUESTED ON</th>
            } @if(showApprovedReturn){
            <th scope="col" style="width: 480px">REQUESTED ON</th>
            } @if(!showApprovedReturn){
            <th scope="col" style="width: 25%">START DATE</th>
            } @if (!showAssetType && !showApprovedReturn) {
            <th scope="col" style="width: 20%">REQUESTED FOR</th>
            } @if(!showApprovedReturn){
            <th scope="col" style="width: 20%">FOR PROJECT</th>
            } @if (showAssetType) {
            <th scope="col" style="width: 15%">URGENCY</th>
            } @if (!showAssetType && !showApprovedReturn) {
            <th scope="col" style="width: 20%">ACTIONS</th>
            } @if (!showApprovedReturn) {
            <th scope="col" style="width: 20%"></th>
            }
            <!-- @if(showApprovedReturn){
              <th scope="col" style="width: 490px;">ACTIONS</th>
              } -->
          </tr>
        </thead>
        <tbody>
          @for (approve of approveInv | slice:0: (viewApprovedUser ?
          inventory.length : 5); track $index) {
          <tr class="">
            <td>
              <div class="d-flex align-items-center" style="width: 80%">
                <p style="margin-bottom: 0; font-size: 13px">
                  {{ $index + 1 }}
                </p>
                @if (!showAssetType) {
                <div class="inventory-img">
                  <img
                    [src]="
                      approve.assetImage && approve.assetImage !== '0'
                        ? approve.assetImage
                        : '../../../../assets/inventories/default-inventory.png '
                    "
                    alt=""
                    width="60px;"
                    height="60px;"
                  />
                </div>
                } @if(!showAssetType){
                <p>{{ approve.assetName }}</p>
                } @if (showAssetType) {
                <p>{{ approve.assetType }}</p>
                }
              </div>
            </td>
            <td>
              <p>{{ approve.requestedOn }}</p>
            </td>

            @if(!showApprovedReturn){
            <td>
              <p>{{ approve.startDate }}</p>
            </td>
            } @if (!showAssetType && !showApprovedReturn) {
            <td>
              <p>{{ approve.requestedFor }} Days</p>
            </td>
            } @if(!showApprovedReturn){
            <td class="project-name">
              <p>{{ approve.project }}</p>
            </td>
            } @if (showAssetType) {
            <td>
              <p
                [ngClass]="{
                  'text-red': approve.urgency === 'High',
                  'text-orange': approve.urgency === 'Medium',
                  'text-blue': approve.urgency === 'Low'
                }"
              >
                {{ approve.urgency }}
              </p>
            </td>
            } @if (!showAssetType && !showApprovedReturn) {
            <td>
              <button
                type="button"
                class="accept submit-img"
                data-toggle="modal"
                data-target="#approvedSubmitImagesModal"
                (click)="setInventoryRequestId(approve.requestId)"
                [disabled]="
                  approve.submittedImagesByUser &&
                  approve.submittedImagesByUser.length > 0
                "
              >
                {{
                  approve.submittedImagesByUser &&
                  approve.submittedImagesByUser.length > 0
                    ? "Images Submitted"
                    : "Submit
                Images"
                }}
              </button>
            </td>
            }
          </tr>
          }
        </tbody>
        @if(approveInv.length === 0){
        <app-no-data></app-no-data>
        }
      </table>
    </div>
    }
    <!-- Service Pending Request Table -->
    @if (showServiceApproved) {
    <div class="checked-out-inv" style="overflow-x: auto">
      <table class="fixed-header-table" style="overflow-x: auto; height: 520px">
        <thead>
          <tr
            style="
              border-top: 1px solid #e7e7e7;
              border-bottom: 1px solid #e7e7e7;
            "
          >
            <th scope="col" style="width: 20%">ASSET NAME</th>
            <th scope="col" style="width: 20%">REQUESTED ON</th>
            <th scope="col" style="width: 20%">SERVICE TYPE</th>
            <th scope="col" style="width: 20%">DAMAGE TYPE</th>
            <th scope="col" style="width: 20%">DETAIL</th>
            <th scope="col" style="width: 20%">URGENCY</th>
          </tr>
        </thead>
        <tbody>
          @for (approve of approveInv | slice:0: (viewApprovedUser ?
          inventory.length : 5); track $index) {
          <tr class="">
            @if (!showAssetType) {
            <td>
              <div class="d-flex align-items-center" style="width: 80%">
                <p style="margin-bottom: 0; font-size: 13px">
                  {{ $index + 1 }}
                </p>
                <div class="inventory-img">
                  <img
                    [src]="
                      approve.assetImage && approve.assetImage !== '0'
                        ? approve.assetImage
                        : '../../../../assets/inventories/default-inventory.png'
                    "
                    alt=""
                    width="60px;"
                    height="60px;"
                  />
                </div>
                <p>{{ approve.assetName }}</p>
              </div>
            </td>
            } @if (showAssetType) {
            <td>
              <p>{{ approve.assetType }}</p>
            </td>
            }
            <td>
              <p>{{ approve.requestedOn }}</p>
            </td>
            <td>
              <p>{{ approve.serviceType }}</p>
            </td>
            <td>
              <p>{{ approve.damageType }}</p>
            </td>
            <td>
              <p>{{ approve.detail }}</p>
            </td>
            <td>
              <p
                [ngClass]="{
                  'text-red': approve.urgency === 'High',
                  'text-orange': approve.urgency === 'Medium',
                  'text-blue': approve.urgency === 'Low'
                }"
              >
                {{ approve.urgency }}
              </p>
            </td>
          </tr>
          }
        </tbody>
        @if(approveInv.length === 0){
        <app-no-data></app-no-data>
        }
      </table>
    </div>
    }
  </div>

  <!-- Pending Request -->
  <div class="checkout-request">
    <div class="checkout-head-cont d-flex justify-content-between">
      <div class="checkout-head d-flex align-items-center">
        <h2>Pending Requests</h2>
        <p>
          <span>{{ this.totalPending }}</span>
        </p>
      </div>
      <div
        class="pending-parent d-flex align-items-center justify-content-center"
      >
        <div class="dropdown" style="margin-bottom: 10px">
          <mat-form-field
            style="width: 185px !important; height: 45px !important"
          >
            <mat-select placeholder="Inventory Request">
              @for (request of requests; track $index) {
              <mat-option
                [value]="request.value"
                (click)="onRequestSelect(request.value)"
              >
                {{ request.viewValue }}
              </mat-option>
              }

              <!-- <mat-option value="Inventory Request" (click)="handleRequestType('Inventory Request')"
                >Inventory Request</mat-option>
                 <mat-option value="Service Request" (click)="handleRequestType('Service Request')"
                >Service Request</mat-option>
                 <mat-option value="New Inventory Request" (click)="handleRequestType('New Inventory Request')"
                >New Inventory Request</mat-option> -->
            </mat-select>
          </mat-form-field>
        </div>
        @if (pendingReq.length > 5) {
        <div class="view-parent">
          <p
            class="view-all"
            (click)="navigateToPending()"
            style="cursor: pointer; margin-left: 10px"
          >
            View All
          </p>
        </div>
        }
        <!-- <button type="button" class="btn btn-warning" style="width: 186px;" data-toggle="modal"
          data-target="#mainRequestModal"><svg width="11" height="11" viewBox="0 0 11 11" fill="none"
            xmlns="http://www.w3.org/2000/svg" style="margin-right: 5px;">
            <path d="M0.484375 5.6084H10.8359" stroke="#030303" stroke-width="1.75" />
            <path d="M5.66016 0.432617L5.66016 10.7842" stroke="#030303" stroke-width="1.75" />
          </svg>
          New Request</button>-->
      </div>
    </div>

    <!--Inventory pending Requests Table -->
    @if (!showServicePending) {
    <div
      class="checked-out-inv"
      infiniteScroll
      #infiniteScroller
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50"
      (scrolled)="onScroll()"
      [scrollWindow]="false"
      style="max-height: 520px; overflow-y: scroll; min-height: 515px"
    >
      <table class="fixed-header-table" style="overflow-x: auto; height: 520px">
        <thead>
          <tr
            style="
              border-top: 1px solid #e7e7e7;
              border-bottom: 1px solid #e7e7e7;
            "
          >
            <th scope="col" style="width: 30%">ASSET NAME</th>
            @if(!showReturnHead){
            <th scope="col" style="width: 25%">REQUESTED ON</th>
            } @if(showReturnHead){
            <th scope="col" style="width: 540px">REQUESTED ON</th>
            } @if (!showReturnHead) {
            <th scope="col" style="width: 25%">START DATE</th>
            } @if(!showReturnHead){
            <th scope="col" style="width: 25%">STATUS</th>
            } @if(showReturnHead){
            <th scope="col" style="width: 520px">STATUS</th>
            } @if (!showReturnHead) {
            <th scope="col" style="width: 30%">FOR PROJECT</th>
            } @if (showUrgency) {
            <th scope="col" style="width: 30%">URGENCY</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (pending of pendingReq | slice:0: (viewPending ?
          pendingReq.length : 5); track $index) {
          <tr class="">
            <td>
              <div class="d-flex align-items-center" style="width: 80%">
                <p style="margin-bottom: 0; font-size: 13px">
                  {{ $index + 1 }}
                </p>
                <div class="inventory-img">
                  <img
                    [src]="
                      pending.assetImage && pending.assetImage !== '0'
                        ? pending.assetImage
                        : '../../../../assets/inventories/default-inventory.png'
                    "
                    alt=""
                    width="60px;"
                    height="60px;"
                  />
                </div>
                <p>{{ pending.assetName }}</p>
                <p>{{ pending.assetType }}</p>
              </div>
            </td>
            <td>
              <p>{{ pending.requestedOn }}</p>
            </td>
            @if (!showReturnHead) {
            <td>
              <p>{{ pending.startDate }}</p>
            </td>
            }
            <td>
              <p
                [ngClass]="{
                  'text-pending': pending.status === 'Pending' || 'Forwarded',
                  'text-rejected': pending.status === 'Rejected By tanvi'
                }"
              >
                {{ pending.status }}
              </p>
            </td>
            @if (!showReturnHead) {
            <td class="project-name">
              <p>{{ pending.project ? pending.project : "-" }}</p>
            </td>
            } @if (showUrgency) {
            <td>
              <p
                [ngClass]="{
                  'text-red': pending.urgency === 'High',
                  'text-orange': pending.urgency === 'Medium',
                  'text-blue': pending.urgency === 'Low'
                }"
              >
                {{ pending.urgency }}
              </p>
            </td>
            }
          </tr>
          }
        </tbody>
        @if(pendingReq.length === 0){
        <app-no-data></app-no-data>
        }
      </table>
    </div>
    }
    <!-- Service Pending Request Table -->
    @if (showServicePending) {
    <div
      class="checked-out-inv"
      infiniteScroll
      #infiniteScroller
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50"
      (scrolled)="onScroll()"
      [scrollWindow]="false"
      style="max-height: 520px; overflow-y: scroll; min-height: 515px"
    >
      <table class="fixed-header-table" style="overflow-x: auto; height: 520px">
        <thead>
          <tr
            style="
              border-top: 1px solid #e7e7e7;
              border-bottom: 1px solid #e7e7e7;
            "
          >
            <th scope="col" style="width: 20%">ASSET NAME</th>
            <th scope="col" style="width: 20%">REQUESTED ON</th>
            <th scope="col" style="width: 15%">SERVICE TYPE</th>
            <th scope="col" style="width: 15%">DAMAGE TYPE</th>
            <th scope="col" style="width: 15%">STATUS</th>
            <th scope="col" style="width: 20%">DETAIL</th>
            <th scope="col" style="width: 20%">URGENCY</th>
          </tr>
        </thead>
        <tbody>
          @for (pending of pendingReq | slice:0: (viewPending ? inventory.length
          : 5); track $index) {
          <tr class="">
            <td>
              <div class="d-flex align-items-center" style="width: 80%">
                <p style="margin-bottom: 0; font-size: 13px">
                  {{ $index + 1 }}
                </p>
                <div class="inventory-img">
                  <img
                    [src]="
                      pending.assetImage && pending.assetImage !== '0'
                        ? pending.assetImage
                        : '../../../../assets/inventories/default-inventory.png'
                    "
                    alt=""
                    width="60px;"
                    height="60px;"
                  />
                </div>
                <p>{{ pending.assetName }}</p>
              </div>
            </td>
            <td>
              <p>{{ pending.requestedOn }}</p>
            </td>
            <td>
              <p>{{ pending.serviceType }}</p>
            </td>
            <td>
              <p>{{ pending.damageType }}</p>
            </td>
            <td>
              <p
                [ngClass]="{
                  'text-pending': pending.status === 'Pending' || 'Forwarded',
                  'text-rejected': pending.status === 'Rejected By tanvi'
                }"
              >
                {{ pending.status }}
              </p>
            </td>
            <td>
              <p>{{ pending.detail }}</p>
            </td>
            <td>
              <p
                [ngClass]="{
                  'text-red': pending.urgency === 'High',
                  'text-orange': pending.urgency === 'Medium',
                  'text-blue': pending.urgency === 'Low'
                }"
              >
                {{ pending.urgency }}
              </p>
            </td>
          </tr>
          }
        </tbody>
        @if(pendingReq.length === 0){
        <app-no-data></app-no-data>
        }
      </table>
    </div>
    }
  </div>

  <!-- Asset Return Requests -->
  <div class="checkout-request">
    <div class="checkout-head-cont d-flex justify-content-between">
      <div class="checkout-head d-flex align-items-center">
        <h2>Asset Return Requests</h2>
        <p>
          <span>{{ this.totalAssetReturn }}</span>
        </p>
      </div>
      @if (assetReturnInv.length > 5) {
      <div class="view-parent">
        <p
          class="view-all"
          (click)="navigateToReturnReq()"
          style="cursor: pointer; margin-left: 10px"
        >
          <!-- {{ viewAAssetReturn ? 'Show Less' : 'Show More' }} -->
          View All
        </p>
      </div>
      }
    </div>

    <!-- Table -->
    <div class="checked-out-inv" style="overflow-x: auto">
      <table class="fixed-header-table" style="overflow-x: auto; height: 520px">
        <thead>
          <tr
            style="
              border-top: 1px solid #e7e7e7;
              border-bottom: 1px solid #e7e7e7;
            "
          >
            <th scope="col" style="width: 600px">ASSET NAME</th>
            <th scope="col" style="width: 400px">REQUESTED ON</th>
            <th scope="col" style="width: 400px">STATUS</th>
            <th scope="col" style="width: 400px">REMARKS</th>
          </tr>
        </thead>
        <tbody>
          @for (asset of assetReturnInv | slice:0: (viewAAssetReturn ?
          assetReturnInv.length : 5); track $index) {
          <tr class="">
            <td>
              <div class="d-flex align-items-center" style="width: 80%">
                <p style="margin-bottom: 0; font-size: 13px">
                  {{ $index + 1 }}
                </p>
                <div class="inventory-img">
                  <img
                    [src]="
                      asset.assetImage && asset.assetImage !== '0'
                        ? asset.assetImage
                        : '../../../../assets/inventories/default-inventory.png'
                    "
                    alt=""
                    width="60px;"
                    height="60px;"
                  />
                </div>
                <p>{{ asset.assetName }}</p>
              </div>
            </td>
            <td>
              <p>{{ asset.requestedOn }}</p>
            </td>

            <td>
              <p
                [ngClass]="{
                  'text-pending': asset.status === 'Pending' || 'Forwarded',
                  'text-rejected': asset.status === 'Rejected By tanvi'
                }"
              >
                {{ asset.status }}
              </p>
            </td>
            <td>
              <p class="remarks-text" title="{{ asset.remarks }}">
                {{ asset.remarks }}
              </p>
            </td>
          </tr>
          }
        </tbody>
        @if(assetReturnInv.length === 0){
        <app-no-data></app-no-data>
        }
      </table>
    </div>

    <!-- Service Pending Request Table -->
    <!-- @if (showServicePending) {
    <div class="checked-out-inv" style="overflow-x: auto">
      <table>
        <thead>
          <tr style="
              border-top: 1px solid #e7e7e7;
              border-bottom: 1px solid #e7e7e7;
            ">
            <th scope="col" style="width: 25%">ASSET NAME</th>
            <th scope="col">REQUESTED ON</th>
            <th scope="col">SERVICE TYPE</th>
            <th scope="col">DAMAGE TYPE</th>
            <th scope="col">STATUS</th>
            <th scope="col">DETAIL</th>
            <th scope="col">URGENCY</th>
          </tr>
        </thead>
        <tbody>
          @for (pending of pendingReq; track $index) {
          <tr class="">
            <td>
              <div class="d-flex align-items-center" style="width: 80%">
                <div class="inventory-img">
                  <img [src]="pending.assetImage" alt="" width="60px;" height="60px;" />
                </div>
                <p>{{pending.assetName}}</p>
              </div>
            </td>
            <td>
              <p>{{pending.requestedOn}}</p>
            </td>
            <td>
              <p>{{pending.serviceType}}</p>
            </td>
            <td>
              <p>{{pending.damageType}}</p>
            </td>
            <td>
              <p [ngClass]="{
                
                'text-pending':pending.status === 'Pending' || 'Forwarded',
                'text-rejected' : pending.status === 'Rejected By tanvi'
              }">{{pending.status}}</p>
            </td>
            <td>
              <p>{{pending.detail}}</p>
            </td>
            <td>
              <p [ngClass]="{
                'text-red':pending.urgency === 'High',
                'text-orange':pending.urgency === 'Medium',
                'text-blue':pending.urgency === 'Low'
              }">{{pending.urgency}}</p>
            </td>
          </tr>
          }


        </tbody>
      </table>
    </div>
    } -->
  </div>
  }

  <!-- Overdue Assets -->
  <div class="checkout-request">
    <div class="checkout-head-cont d-flex justify-content-between">
      <div class="checkout-head d-flex align-items-center">
        <h2>Overdue Assets</h2>
        <p>
          <span>{{ this.totalOverdueAssets }}</span>
        </p>
      </div>
      @if (overdueAssets.length > 5) {
      <div class="view-parent">
        <p
          class="view-all"
          (click)="viewAll = !viewAll"
          style="cursor: pointer"
        >
          {{ viewAll ? "Show Less" : "Show More" }}
          <!-- View All -->
        </p>
      </div>
      }
    </div>

    <!-- Overdue Assets Table -->
    <div
      class="checked-out-inv"
      infiniteScroll
      #infiniteScroller
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50"
      (scrolled)="onScroll()"
      [scrollWindow]="false"
      style="max-height: 520px; overflow-y: scroll"
    >
      <table class="fixed-header-table" style="height: 520px">
        <thead>
          <tr
            style="
              border-top: 1px solid #e7e7e7;
              border-bottom: 1px solid #e7e7e7;
            "
          >
            <th scope="col" style="width: 25%">ASSET NAME</th>
            <th scope="col" style="width: 25%">TAKEN BY</th>
            <th scope="col" style="width: 25%">TAKEN FOR</th>
            <th scope="col" style="width: 25%">TAKEN ON</th>
            <th scope="col" style="width: 25%">OVERDUE FOR</th>
            <th scope="col" style="width: 25%">ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          @for (overdue of overdueAssets | slice:0:(viewAll ?
          overdueAssets.length : 5); track $index){
          <tr>
            <td>
              <div class="d-flex align-items-center" style="width: 80%">
                <p style="margin-bottom: 0; font-size: 13px">
                  {{ $index + 1 }}
                </p>
                <div class="inventory-img">
                  <img
                    [src]="
                      overdue.assetImage && overdue.assetImage !== '0'
                        ? overdue.assetImage
                        : '../../../../assets/inventories/default-inventory.png'
                    "
                    alt=""
                    width="60px"
                    height="60px"
                  />
                </div>
                <p>{{ overdue.assetName }}</p>
              </div>
            </td>
            <td>
              <p>{{ overdue.userName }}</p>
            </td>
            <td>
              <p>{{ overdue.takenFor }}Days</p>
            </td>
            <td>
              <p>{{ overdue.takenOn }}</p>
            </td>
            <td>
              <p class="text-forward">{{ overdue.overdueFor }}Days</p>
            </td>

            <td>
              <div class="d-flex align-items-center justify-content-between">
                @if(showUserDashboard){
                <button
                  class="send"
                  style="margin-right: 10px"
                  data-target="#assetOverdueModal"
                  data-toggle="modal"
                  (click)="openOverdueAsset($index)"
                >
                  Send Reminder
                </button>
                <button class="sent d-none">
                  <svg
                    width="13"
                    height="10"
                    viewBox="0 0 13 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="margin-right: 5px"
                  >
                    <path
                      d="M1.76489 4.95386L5.23359 8.5006L12.0059 1.57594"
                      stroke="#24BA61"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Reminder Sent
                </button>
                <button
                  type="button"
                  class="take-action"
                  data-target="#overdueExtendModal"
                  data-toggle="modal"
                  (click)="openReturn(overdue.assignedInventoryId, $index)"
                >
                  Extend
                </button>
                } @if(!showUserDashboard){

                <!-- Extend -->
                <button
                  class="extend-action"
                  style="margin-right: 10px"
                  (click)="openReturn(overdue.assignedInventoryId, $index)"
                  data-target="#assignedExtendModal"
                  data-toggle="modal"
                  [disabled]="
                    overdue.isExtendRequested || overdue.isReturnRequested
                  "
                >
                  {{
                    overdue.isExtendRequested ? "Extend Requested" : "Extend"
                  }}
                </button>

                <!-- Return -->
                <button
                  class="decline"
                  data-toggle="modal"
                  data-target="#assignedReturnModal"
                  (click)="openReturn(overdue.assignedInventoryId, $index)"
                  [disabled]="
                    overdue.isReturnRequested || overdue.isExtendRequested
                  "
                  [ngClass]="{ 'return-requested': overdue.isReturnRequested }"
                >
                  {{
                    overdue.isReturnRequested ? "Return Requested" : "Return"
                  }}
                </button>

                }
              </div>
            </td>
          </tr>
          }
        </tbody>
        @if(overdueAssets.length === 0){
        <app-no-data></app-no-data>
        }
      </table>
    </div>
  </div>
</div>

<!-- Charging Reminder Modal -->
<div
  class="modal fade"
  id="chargingReminderModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="chargingReminderTitle"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered charging-reminder-width"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header charging-head">
        <h1>Charging Reminder</h1>
        <button
          type="button"
          class="close inven-cls"
          data-dismiss="modal"
          aria-label="Close"
        >
          <svg
            class="cross-svg"
            width="14"
            height="12"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5518 1.64453L1.85612 12.3402"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
            <path
              d="M12.5518 12.3401L1.85612 1.64445"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
      <div class="modal-body charging-container">
        <div class="sent-req-content">
          <form [formGroup]="chargingReminderForm">
            <div class="form-row">
              <div class="form-group col-md-6">
                <p class="labelish">Does product have Battery?</p>
                <div class="rd-button d-flex">
                  <div
                    class="d-flex justify-content-between align-items-center"
                    style="margin-right: 30px"
                  >
                    <input
                      id="yes1"
                      type="radio"
                      value="BatteryValue"
                      formControlName="chargingBatteryType"
                    />
                    <label for="yes1">Yes</label>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center mg-left"
                  >
                    <input
                      id="no1"
                      type="radio"
                      value="BatteryValue"
                      formControlName="chargingBatteryType"
                    />
                    <label for="no1">No</label>
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label for="first-date">Charged on</label>
                <input
                  type="date"
                  id="first-contact"
                  name="contact"
                  formControlName="firstContactDate"
                  required
                  style="width: 290px"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="first-date">Mention Reason</label>
                <input
                  type="text"
                  id="first-contact"
                  name="contact"
                  formControlName="reason"
                  required
                  style="width: 290px; padding: 10px"
                />
              </div>
            </div>
          </form>
          <button
            class="btn bulk-upload d-flex align-items-center justify-content-center"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Overdue Asset Extend  -->
<div
  class="modal fade"
  id="overdueExtendModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="chargingReminderTitle"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered charging-reminder-width"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header charging-head">
        <button
          type="button"
          class="close inven-cls"
          data-dismiss="modal"
          aria-label="Close"
        >
          <svg
            class="cross-svg"
            width="14"
            height="12"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5518 1.64453L1.85612 12.3402"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
            <path
              d="M12.5518 12.3401L1.85612 1.64445"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
      <div class="modal-body charging-container">
        <h1 class="text-center" style="font-size: 34px; margin-bottom: 40px">
          Overdue Asset Extend
        </h1>
        <div class="sent-req-content">
          <form class="" [formGroup]="extendRequestForm">
            <label for="extend" style="font-size: 18px; font-weight: 600"
              >Extend Till</label
            >
            <input
              type="date"
              style="
                width: 300px;
                padding: 10px 15px;
                border-radius: 8px;
                border: 1px solid #e7e7e7;
                margin-left: 10px;
                margin-bottom: 70px;
              "
              id="extend"
              formControlName="extendTill"
              [min]="today"
              (keydown)="disableTyping($event)"
            />
            <div
              class="d-flex align-items-center justify-content-center"
              style="margin-bottom: 25px"
            >
              <button
                class="btn btn-warning close send-request"
                data-dismiss="modal"
                aria-label="Close"
                (click)="onRequestOverdueExtend()"
              >
                Send Request
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Inventory Return Request Modal -->
@for (return of returnInv; track $index) {
<div
  class="modal fade"
  id="inventoryReturnReqModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="assetReturnReqModalTitle"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered return-req-slider"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="assetReturnReqModalLongTitle">
          Asset Return Request
        </h5>
        <button
          type="button"
          class="close inven-cls"
          data-dismiss="modal"
          aria-label="Close"
        >
          <svg
            class="cross-svg"
            width="14"
            height="12"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5518 1.64453L1.85612 12.3402"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
            <path
              d="M12.5518 12.3401L1.85612 1.64445"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
      <div class="modal-body">
        @if (!showDeclineForm) {
        <div class="">
          <h6
            style="
              padding-bottom: 25px;
              text-align: center;
              font-weight: 600;
              font-size: 24px;
            "
          >
            Photos Uploaded By User
          </h6>
          <div
            id="productImagecarousel"
            class="carousel slide product-carousel"
            data-ride="carousel"
            data-interval="false"
            style="margin: 0 auto"
          >
            <ol class="carousel-indicators return-pointers">
              <li
                data-target="#carouselExampleIndicators"
                data-slide-to="0"
                class="active"
              ></li>
              @for ( productImg of previewReturnImg?.images.slice(1) ; track
              $index) {
              <li
                data-target="#carouselExampleIndicators"
                attr.data-slide-to="{{ $index }}"
              ></li>

              }
            </ol>
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  [src]="
                    previewReturnImg?.images[0]
                      ? previewReturnImg?.images[0]
                      : '../../../assets/inventories/computer-system.jpg'
                  "
                  class="d-block"
                  alt="..."
                  style="
                    width: 380px;
                    height: 290px;
                    margin: 16px auto;
                    object-fit: contain;
                  "
                />
              </div>
              @for ( productImg of previewReturnImg?.images.slice(1) ; track
              $index) {
              <div class="carousel-item">
                <img
                  [src]="[productImg]"
                  class="d-block"
                  alt="..."
                  style="width: fit-content; height: 290px; margin: 16px auto"
                />
              </div>
              }
            </div>

            <button
              class="carousel-control-prev"
              type="button"
              data-target="#productImagecarousel"
              data-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="sr-only">Previous</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-target="#productImagecarousel"
              data-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="sr-only">Next</span>
            </button>
          </div>
          <div
            class="asset-rtn-button d-flex justify-content-center align-items-center"
            style="margin: 60px 0 40px 0"
          >
            <button
              class="close btn btn-accept"
              (click)="acceptReturnRequest(return.requestId)"
              data-dismiss="modal"
              aria-label="Close"
            >
              Accept Request
            </button>
            <button
              class="close btn btn-decline"
              data-dismiss="modal"
              aria-label="Close"
              (click)="onDeclineButtonClick()"
            >
              Decline Request
            </button>
          </div>
        </div>
        } @if (showDeclineForm) {
        <div class="reject-container">
          <h6
            style="
              padding-bottom: 25px;
              text-align: center;
              font-weight: 600;
              font-size: 24px;
            "
          >
            Reject Request
          </h6>
          <form [formGroup]="declineReasonForm">
            <div
              class="d-flex flex-column justify-content-center"
              style="margin: 0 auto; width: 700px"
            >
              <label for="rejectionReason">Comment</label>
              <textarea
                id="rejectionReason"
                name="contact"
                rows="3"
                formControlName="rejectionReason"
                required
              >
              </textarea>
            </div>
            <button
              class="close 333 inven-close btn btn-decline d-flex justify-content-center align-items-center"
              style="margin: 30px auto; opacity: 1 !important"
              (click)="
                !isProcessingAction && rejectReturnRequest(return.requestId)
              "
              [disabled]="isProcessingAction"
              data-dismiss="modal"
              aria-label="Close"
            >
              Confirm Reject Request
            </button>
          </form>
        </div>
        }
      </div>
    </div>
  </div>
</div>
}

<!-- Assigned Extend Request -->
<div
  class="modal fade"
  id="assignedExtendModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="chargingReminderTitle"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered charging-reminder-width"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header charging-head">
        <button
          type="button"
          class="close inven-cls"
          data-dismiss="modal"
          aria-label="Close"
        >
          <svg
            class="cross-svg"
            width="14"
            height="12"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5518 1.64453L1.85612 12.3402"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
            <path
              d="M12.5518 12.3401L1.85612 1.64445"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
      <div class="modal-body charging-container">
        <h1 class="text-center" style="font-size: 34px; margin-bottom: 40px">
          Request Extend Return Date
        </h1>
        <div class="sent-req-content">
          <form [formGroup]="extendRequestForm">
            <label for="extend" style="font-size: 15px">Extend Till</label>
            <br />
            <input
              type="date"
              style="
                width: 300px;
                padding: 10px 15px;
                border-radius: 8px;
                border: 1px solid #e7e7e7;
                margin-left: 10px;
                margin-bottom: 70px;
              "
              id="extend"
              formControlName="extendTill"
              [min]="today"
              (keydown)="disableTyping($event)"
            />
            <div
              class="d-flex align-items-center justify-content-center"
              style="margin-bottom: 25px"
            >
              <button
                class="btn btn-warning close send-request"
                data-dismiss="modal"
                aria-label="Close"
                (click)="onRequestExtend()"
              >
                Send Request
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Assigned Return Modal -->
<div
  class="modal fade"
  id="assignedReturnModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="chargingReminderTitle"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered assigned-return-width"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header charging-head">
        <h1>Upload Asset Images</h1>
        <button
          type="button"
          class="close inven-cls"
          data-dismiss="modal"
          aria-label="Close"
        >
          <svg
            class="cross-svg"
            width="14"
            height="12"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5518 1.64453L1.85612 12.3402"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
            <path
              d="M12.5518 12.3401L1.85612 1.64445"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
      <div class="modal-body charging-container">
        @if (!showForwardSuccess) {
        <div class="sent-req-content">
          <form [formGroup]="uploadAssetImageForm">
            <div class="form-row">
              @if (selectedFiles.length < 4) {
              <div class="form-group col-md-12">
                <div class="invoice-upload">
                  <div class="invoice-content" style="left: 39%">
                    <svg
                      width="54"
                      height="37"
                      viewBox="0 0 54 37"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M43.0897 13.9457C41.5792 6.28235 34.8488 0.529297 26.7634 0.529297C20.344 0.529297 14.7687 4.17215 11.9921 9.50316C5.30613 10.214 0.108398 15.8782 0.108398 22.7418C0.108398 30.0942 6.08357 36.0694 13.4359 36.0694H42.3122C48.4429 36.0694 53.4185 31.0938 53.4185 24.9631C53.4185 19.099 48.8649 14.3455 43.0897 13.9457ZM42.3122 31.6269H13.4359C8.52695 31.6269 4.55091 27.6508 4.55091 22.7418C4.55091 18.1883 7.94943 14.3899 12.4586 13.9235L14.8353 13.6791L15.9459 11.5689C18.0561 7.50404 22.1877 4.97181 26.7634 4.97181C32.5831 4.97181 37.6032 9.10334 38.736 14.812L39.4024 18.1438L42.8009 18.3882C46.2661 18.6103 48.976 21.5202 48.976 24.9631C48.976 28.6282 45.9773 31.6269 42.3122 31.6269ZM17.8784 20.5206H23.5426V27.1843H29.9843V20.5206H35.6485L26.7634 11.6356L17.8784 20.5206Z"
                        fill="#030303"
                      />
                    </svg>
                    <p class="drag-text">
                      <span>Drag your file(s)</span>
                    </p>
                    <p
                      class="file-size"
                      style="font-weight: 400; font-size: 16px"
                    >
                      Max 10 MB files are allowed
                    </p>
                  </div>
                  <input
                    type="file"
                    class="form-control"
                    formControlName="assetImage"
                    accept=".png,.jpeg"
                    (change)="onFileSelected($event)"
                    multiple
                    style="width: 100% !important"
                  />
                </div>
                <p
                  class="text-left"
                  style="font-weight: 400; font-size: 16px; padding-top: 15px"
                >
                  <span>Maximum 4 files</span>
                </p>
              </div>
              }

              <div
                class="form-group col-md-12 d-flex justify-content-between flex-wrap flex-row"
              >
                @for (file of selectedFiles; track $index) {
                <div
                  class="col-md-5 d-flex justify-content-between align-items-center uploaded-images"
                  style="margin-bottom: 15px"
                >
                  <div class="d-flex align-items-center">
                    <img
                      [src]="file.preview"
                      alt=""
                      width="60px"
                      height="60px"
                    />
                    <div style="padding-left: 10px">
                      <p style="margin-bottom: 0; font-weight: 400">
                        {{ file.name }}
                      </p>
                      <span class="text-left">{{ file.size }}kb</span>
                    </div>
                  </div>
                  <svg
                    width="31"
                    height="31"
                    viewBox="0 0 31 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    (click)="removeFile(file)"
                    style="cursor: pointer"
                  >
                    <circle
                      opacity=" 0.1"
                      cx="15.3789"
                      cy="15.5879"
                      r="15"
                      fill="#030303"
                    />
                    <path
                      d="M11.5723 11.7832L19.1813 19.3923"
                      stroke="#030303"
                      stroke-width="1.56126"
                      stroke-linecap="round"
                    />
                    <path
                      d="M19.1816 11.7832L11.5726 19.3923"
                      stroke="#030303"
                      stroke-width="1.56126"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                }
              </div>
            </div>
            <button
              type="button"
              class="btn btn-warning upload-submit"
              (click)="onReturnSubmit()"
            >
              Upload And Submit
            </button>
          </form>
        </div>
        } @if (showForwardSuccess) {
        <div class="sent-req-content">
          <svg
            class="tick-mark"
            width="76"
            height="76"
            viewBox="0 0 76 76"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M37.7808 3.91014C46.0698 3.91014 54.0763 6.92354 60.3083 12.3889C66.5404 17.8543 70.573 25.3989 71.655 33.617C72.7369 41.8352 70.7943 50.1664 66.1892 57.0586C61.584 63.9507 54.6303 68.9336 46.6237 71.079C38.6171 73.2244 30.1035 72.3858 22.6693 68.7197C15.2351 65.0535 9.38711 58.8097 6.21502 51.1516C3.04292 43.4935 2.76302 34.9434 5.42745 27.0942C8.09189 19.245 13.5189 12.6321 20.6975 8.48759"
              stroke="#24BA61"
              stroke-width="6.40622"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M24.9683 38.0768L33.5099 46.6184L50.5932 29.5352"
              stroke="#24BA61"
              stroke-width="5.33852"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <h3>Request Sent</h3>

          <p class="return-sent-msg">
            Your request has been sent for approval, you will be <br />
            notified once it gets approved by superadmin
          </p>
          <div class="d-flex justify-content-center align-items-center">
            <button
              class="btn btn-warning close"
              style="width: 210px; opacity: 1; font-size: 16px; height: 48px"
              data-dismiss="modal"
              aria-label="Close"
            >
              Okay
            </button>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>

<!-- Approved Submit Images Modal-->
<div
  class="modal fade"
  id="approvedSubmitImagesModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="chargingReminderTitle"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-centered assigned-return-width"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header charging-head">
        <h1>Upload Asset Images</h1>
        <button
          type="button"
          class="close inven-cls"
          data-dismiss="modal"
          aria-label="Close"
        >
          <svg
            class="cross-svg"
            width="14"
            height="12"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5518 1.64453L1.85612 12.3402"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
            <path
              d="M12.5518 12.3401L1.85612 1.64445"
              stroke="#25252B"
              stroke-width="2.26313"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
      <div class="modal-body charging-container">
        @if (!showForwardSuccess) {
        <div class="sent-req-content">
          <form [formGroup]="uploadAssetImageForm">
            <div class="form-row">
              @if (selectedFiles.length < 4) {
              <div class="form-group col-md-12">
                <div class="invoice-upload">
                  <div class="invoice-content" style="left: 39%">
                    <svg
                      width="54"
                      height="37"
                      viewBox="0 0 54 37"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M43.0897 13.9457C41.5792 6.28235 34.8488 0.529297 26.7634 0.529297C20.344 0.529297 14.7687 4.17215 11.9921 9.50316C5.30613 10.214 0.108398 15.8782 0.108398 22.7418C0.108398 30.0942 6.08357 36.0694 13.4359 36.0694H42.3122C48.4429 36.0694 53.4185 31.0938 53.4185 24.9631C53.4185 19.099 48.8649 14.3455 43.0897 13.9457ZM42.3122 31.6269H13.4359C8.52695 31.6269 4.55091 27.6508 4.55091 22.7418C4.55091 18.1883 7.94943 14.3899 12.4586 13.9235L14.8353 13.6791L15.9459 11.5689C18.0561 7.50404 22.1877 4.97181 26.7634 4.97181C32.5831 4.97181 37.6032 9.10334 38.736 14.812L39.4024 18.1438L42.8009 18.3882C46.2661 18.6103 48.976 21.5202 48.976 24.9631C48.976 28.6282 45.9773 31.6269 42.3122 31.6269ZM17.8784 20.5206H23.5426V27.1843H29.9843V20.5206H35.6485L26.7634 11.6356L17.8784 20.5206Z"
                        fill="#030303"
                      />
                    </svg>
                    <p class="drag-text">
                      <span>Drag your file(s)</span>
                    </p>
                    <p
                      class="file-size"
                      style="font-weight: 400; font-size: 16px"
                    >
                      Max 10 MB files are allowed
                    </p>
                  </div>
                  <input
                    type="file"
                    class="form-control"
                    formControlName="assetImage"
                    accept=".png,.jpeg"
                    (change)="onApprovedSubmitImages($event)"
                    multiple
                    style="width: 100% !important"
                  />
                </div>
                <p
                  class="text-left"
                  style="font-weight: 400; font-size: 16px; padding-top: 15px"
                >
                  <span>Maximum 4 files</span>
                </p>
              </div>
              }

              <div
                class="form-group col-md-12 d-flex justify-content-between flex-wrap flex-row"
              >
                @for (file of selectedFiles; track $index) {
                <div
                  class="col-md-5 d-flex justify-content-between align-items-center uploaded-images"
                  style="margin-bottom: 15px"
                >
                  <div class="d-flex align-items-center">
                    <img
                      [src]="file.preview"
                      alt=""
                      width="60px"
                      height="60px"
                    />
                    <div style="padding-left: 10px">
                      <p style="margin-bottom: 0; font-weight: 400">
                        {{ file.name }}
                      </p>
                      <span class="text-left">{{ file.size }}kb</span>
                    </div>
                  </div>
                  <svg
                    width="31"
                    height="31"
                    viewBox="0 0 31 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    (click)="removeFile(file)"
                    style="cursor: pointer"
                  >
                    <circle
                      opacity=" 0.1"
                      cx="15.3789"
                      cy="15.5879"
                      r="15"
                      fill="#030303"
                    />
                    <path
                      d="M11.5723 11.7832L19.1813 19.3923"
                      stroke="#030303"
                      stroke-width="1.56126"
                      stroke-linecap="round"
                    />
                    <path
                      d="M19.1816 11.7832L11.5726 19.3923"
                      stroke="#030303"
                      stroke-width="1.56126"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
                }
              </div>
            </div>
            <button
              type="button"
              class="btn btn-warning upload-submit"
              (click)="onApprovedSubmitImg()"
            >
              Upload And Submit
            </button>
          </form>
        </div>
        } @if (showForwardSuccess) {
        <div class="sent-req-content">
          <svg
            class="tick-mark"
            width="76"
            height="76"
            viewBox="0 0 76 76"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M37.7808 3.91014C46.0698 3.91014 54.0763 6.92354 60.3083 12.3889C66.5404 17.8543 70.573 25.3989 71.655 33.617C72.7369 41.8352 70.7943 50.1664 66.1892 57.0586C61.584 63.9507 54.6303 68.9336 46.6237 71.079C38.6171 73.2244 30.1035 72.3858 22.6693 68.7197C15.2351 65.0535 9.38711 58.8097 6.21502 51.1516C3.04292 43.4935 2.76302 34.9434 5.42745 27.0942C8.09189 19.245 13.5189 12.6321 20.6975 8.48759"
              stroke="#24BA61"
              stroke-width="6.40622"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M24.9683 38.0768L33.5099 46.6184L50.5932 29.5352"
              stroke="#24BA61"
              stroke-width="5.33852"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <h3>Images Submitted</h3>

          <p>
            Images has been submitted, please find the location <br />
            below to pickup the product
          </p>

          <p
            style="
              width: 42%;
              margin: 0 auto;
              color: #000000;
              border: 1px solid #e7e7e7;
              border-radius: 8px;
              padding: 15px;
            "
          >
            <span style="color: #030303; opacity: 0.6; font-weight: 500"
              >Pickup Location:
            </span>
            {{ this.subImg }}
          </p>

          <div class="d-flex justify-content-center align-items-center">
            <button
              class="btn btn-warning close"
              style="
                width: 210px;
                opacity: 1;
                margin-top: 20px;
                font-size: 16px;
                height: 48px;
              "
              data-dismiss="modal"
              aria-label="Close"
            >
              Okay
            </button>
          </div>
        </div>
        }
      </div>
    </div>
  </div>

  <!-- Main Request Modal -->
  <div
    class="modal fade"
    id="mainRequestModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="chargingReminderTitle"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered main-req-width"
      role="document"
    >
      <div class="modal-content" style="height: 400px">
        <div class="modal-header charging-head">
          <button
            type="button"
            class="close inven-cls"
            data-dismiss="modal"
            aria-label="Close"
          >
            <svg
              class="cross-svg"
              width="14"
              height="12"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.5518 1.64453L1.85612 12.3402"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
              <path
                d="M12.5518 12.3401L1.85612 1.64445"
                stroke="#25252B"
                stroke-width="2.26313"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
        <div class="modal-body charging-container">
          <h2 class="text-center" style="font-size: 34px; padding-bottom: 30px">
            Select A Request Type
          </h2>

          <div
            class="request-btn d-flex justify-content-center align-items-center"
            style="margin: 52px auto"
          >
            <button
              type="button"
              class="req-btn"
              routerLinkActive="router-link-active"
              routerLink="/inventory/new-inventory"
            >
              New Inventory
            </button>
            <button
              type="button"
              class="req-btn"
              routerLink="/inventory/inventory-request"
            >
              Inventory Request
            </button>
            <button
              type="button"
              class="req-btn"
              routerLink="/inventory/service"
            >
              Service Request
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Forward New Inventory Request Modal -->
<app-forward-req
  [selectedInventory]="selectedInventory"
  [newInvReqId]="newInvReqId"
  (requestForwarded)="onRequestForwarded($event)"
></app-forward-req>
<!-- Forward Service Request Modal -->
<app-forward-service-req
  [selectedServiceInventory]="selectedSerInventory"
  (requestForwarded)="onServiceForwarded($event)"
></app-forward-service-req>

<!-- Admin Asset Overdue Modal -->
